
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gR27Z", function(module, exports) {
/* Reactions.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $aRGok = parcelRequire("aRGok");


var $a1L5E = parcelRequire("a1L5E");


var $iDrrr = parcelRequire("iDrrr");


var $3aKBk = parcelRequire("3aKBk");


var $lbdYm = parcelRequire("lbdYm");


var $jFWFL = parcelRequire("jFWFL");


var $jOmQq = parcelRequire("jOmQq");


var $97zIA = parcelRequire("97zIA");


var $j2uPw = parcelRequire("j2uPw");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $hMjUh = parcelRequire("hMjUh");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $iMnC5 = parcelRequire("iMnC5");





























var $arQY7 = parcelRequire("arQY7");


var $lfoFx = parcelRequire("lfoFx");


var $gRGWz = parcelRequire("gRGWz");




var $4ez2K = parcelRequire("4ez2K");

const $0adbe123f7e78edb$var$userListStyle = null;
const $0adbe123f7e78edb$var$userStyle = null;
const $0adbe123f7e78edb$var$styles = {
    userDescriptionStyle: "_2XsHFM8HPE",
    profileWrapperStyle: "_2XsHFMPgdg",
    reactionViewStyle: "_3138428HPE _4kiQYABfNa _4ouGXIbAsb",
    centerSpinnerStyle: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VN91d _313842NHnM"
};
const $0adbe123f7e78edb$export$5ad09c2943879b39 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { reaction: reaction, ProfileCardWrapper: ProfileCardWrapper } = t0;
    const reactionObj = reaction;
    let t1;
    if ($[0] !== reactionObj.users) {
        t1 = reactionObj.users?.sort($0adbe123f7e78edb$var$_temp) || [];
        $[0] = reactionObj.users;
        $[1] = t1;
    } else t1 = $[1];
    const alphabeticalNames = t1;
    let t2;
    if ($[2] !== ProfileCardWrapper || $[3] !== alphabeticalNames) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $gRGWz.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: $0adbe123f7e78edb$var$styles.reactionViewStyle
        }, alphabeticalNames.length === 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0adbe123f7e78edb$var$styles.centerSpinnerStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "large",
            interactionName: "reactions-spinner"
        })) : /*#__PURE__*/ $cozmU.createElement("ul", {
            className: (0, $hekY6.default)([
                "_1LMyvKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3138425zaO _2fwxA5ecOK _1xwpxGmnOE _1WG9Way7kJ"
            ])
        }, alphabeticalNames.map((user)=>{
            const profile = user.profilePicture?.path;
            return /*#__PURE__*/ $cozmU.createElement("li", {
                key: user.id,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0hPCNLDIqT _0Of8r21Y8M _1wydGW1Y8M _2Zuz6QdnbC _1ZnuxbdnbC _08IXD05zaO"
                ])
            }, ProfileCardWrapper && user.accountId ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $0adbe123f7e78edb$var$styles.profileWrapperStyle
            }, /*#__PURE__*/ $cozmU.createElement(ProfileCardWrapper, {
                userId: user.accountId,
                isAnonymous: false,
                canViewProfile: true,
                position: "left-start"
            }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
                size: "medium",
                src: profile,
                testId: "profile"
            }))) : /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
                size: "medium",
                src: profile,
                testId: "profile"
            }), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                xcss: $0adbe123f7e78edb$var$styles.userDescriptionStyle
            }, /*#__PURE__*/ $cozmU.createElement("div", null, user.displayName)));
        }))));
        $[2] = ProfileCardWrapper;
        $[3] = alphabeticalNames;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ reaction: reaction, ProfileCardWrapper: ProfileCardWrapper })=>{
    const alphabeticalNames = (0, $cozmU.useMemo)(()=>{
        const reactionObj = reaction;
        return reactionObj.users?.sort((a, b)=>a.displayName.localeCompare(b.displayName)) || [];
    }, [
        reaction
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $gRGWz.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        xcss: $0adbe123f7e78edb$var$styles.reactionViewStyle
    }, alphabeticalNames.length === 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0adbe123f7e78edb$var$styles.centerSpinnerStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "reactions-spinner"
    })) : /*#__PURE__*/ $cozmU.createElement("ul", {
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3138425zaO _2fwxA5ecOK _1xwpxGmnOE _1WG9Way7kJ"
        ])
    }, alphabeticalNames.map((user)=>{
        const profile = user.profilePicture?.path;
        return /*#__PURE__*/ $cozmU.createElement("li", {
            key: user.id,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0hPCNLDIqT _0Of8r21Y8M _1wydGW1Y8M _2Zuz6QdnbC _1ZnuxbdnbC _08IXD05zaO"
            ])
        }, ProfileCardWrapper && user.accountId ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0adbe123f7e78edb$var$styles.profileWrapperStyle
        }, /*#__PURE__*/ $cozmU.createElement(ProfileCardWrapper, {
            userId: user.accountId,
            isAnonymous: false,
            canViewProfile: true,
            position: "left-start"
        }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            size: "medium",
            src: profile,
            testId: "profile"
        }))) : /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            size: "medium",
            src: profile,
            testId: "profile"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $0adbe123f7e78edb$var$styles.userDescriptionStyle
        }, /*#__PURE__*/ $cozmU.createElement("div", null, user.displayName)));
    }))));
};
function $0adbe123f7e78edb$var$_temp(a, b) {
    return a.displayName.localeCompare(b.displayName);
}


const $28b3de9cab4acb5c$export$a87089fe362b9d93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { reactions: reactions, selectedEmojiId: selectedEmojiId, ProfileCardWrapper: ProfileCardWrapper } = t0;
    let t1;
    if ($[0] !== ProfileCardWrapper || $[1] !== reactions || $[2] !== selectedEmojiId) {
        let t2;
        if ($[4] !== ProfileCardWrapper || $[5] !== selectedEmojiId) {
            t2 = (reaction)=>{
                if (reaction.emojiId === selectedEmojiId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0adbe123f7e78edb$export$5ad09c2943879b39), {
                    key: reaction.emojiId,
                    reaction: reaction,
                    ProfileCardWrapper: ProfileCardWrapper
                });
                else return null;
            };
            $[4] = ProfileCardWrapper;
            $[5] = selectedEmojiId;
            $[6] = t2;
        } else t2 = $[6];
        t1 = reactions.map(t2);
        $[0] = ProfileCardWrapper;
        $[1] = reactions;
        $[2] = selectedEmojiId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ reactions: reactions, selectedEmojiId: selectedEmojiId, ProfileCardWrapper: ProfileCardWrapper })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, reactions.map((reaction)=>{
        if (reaction.emojiId === selectedEmojiId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0adbe123f7e78edb$export$5ad09c2943879b39), {
            key: reaction.emojiId,
            reaction: reaction,
            ProfileCardWrapper: ProfileCardWrapper
        });
        else return null;
    }));
};


















var $IQ4Dz = parcelRequire("IQ4Dz");


var $cDs9S = parcelRequire("cDs9S");


var $bxtKM = parcelRequire("bxtKM");


var $dkVNA = parcelRequire("dkVNA");






var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $aGB72 = parcelRequire("aGB72");





var $lpNn5 = parcelRequire("lpNn5");


var $aDSIl = parcelRequire("aDSIl");


var $iW7aI = parcelRequire("iW7aI");


var $6OpMl = parcelRequire("6OpMl");





var $9UzxD = parcelRequire("9UzxD");




const $2634b67aa7c4350a$var$styles = {
    leftNavigationStyle: "_3138421Y8M _4xdlr0R7aE _2Zuz6Q5zaO _1wydGW8HPE",
    rightNavigationStyle: "_3138421Y8M _4xdlr0R7aE _2XsHFMIZbP _0adFHs2ADO",
    fullWidthStyle: "_39xV02N91d _0Of8r2NHnM _2Zuz6QNHnM _1ZnuxbNHnM _0xmtkoVa5s",
    emoji: "_4c065U1Y8M _0yKXXaDGiX _0LQT5E2ADO _03SyCP1Y8M",
    counterStyle: "_313842FQfX"
};
const $2634b67aa7c4350a$var$REACTIONS_CONTAINER_WIDTH = 56;
const $2634b67aa7c4350a$var$REACTION_CONTAINER_HEIGHT = 40;
const $2634b67aa7c4350a$var$customTabListStyles = null;
const $2634b67aa7c4350a$var$customTabWrapper = {
    base: "_3YEZNOdnbC _3iDTPbQ4SZ _0aFT5vbt8w _2fwxA5DIqT _0hPCNLDIqT _37wbyuDIqT _4ouGXImdCj _24h04i2Njc _1mT5xdRAKS _1C8dRaAASz _0rUhZjAASz _3c7I3RAASz _1stIVYAASz _0qRrkpmdCj _4EeuowUF4f _0VdfO7DIqT _1WMabhDIqT _1y7d8OTFQX _0bu9Bbogpp _1vJN9LWVPG _0IIxcqdnbC _4B8qZSdnbC _3s5ErCmdCj _1Py4UeUF4f _3H9klIdnbC _1gogL6INwl _0Nbas4ogpp _4xh3Z9WVPG _0m3eUKdnbC _0Pz6hydnbC _3KlDlumdCj _3C4BpoUF4f _0y2qr2dnbC _2oOvNHey7F _0GCLsBey7F",
    darkTheme: "_1y7d8Ocbvn _1gogL60miN"
};
const $2634b67aa7c4350a$var$firstElement = null;
const $2634b67aa7c4350a$var$LeftNavigationButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { handlePreviousPage: handlePreviousPage } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $jFWFL.messages).leftNavigateLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== handlePreviousPage || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $2634b67aa7c4350a$var$styles.leftNavigationStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            spacing: "compact",
            onClick: handlePreviousPage,
            icon: $2634b67aa7c4350a$var$_temp,
            label: t1,
            isTooltipDisabled: false
        }));
        $[2] = handlePreviousPage;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ handlePreviousPage: handlePreviousPage })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $2634b67aa7c4350a$var$styles.leftNavigationStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        spacing: "compact",
        onClick: handlePreviousPage,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            }),
        label: intl.formatMessage((0, $jFWFL.messages).leftNavigateLabel),
        isTooltipDisabled: false
    }));
};
const $2634b67aa7c4350a$var$RightNavigationButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { handleNextPage: handleNextPage } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $jFWFL.messages).rightNavigateLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== handleNextPage || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $2634b67aa7c4350a$var$styles.rightNavigationStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            spacing: "compact",
            onClick: handleNextPage,
            icon: $2634b67aa7c4350a$var$_temp2,
            label: t1,
            isTooltipDisabled: false
        }));
        $[2] = handleNextPage;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ handleNextPage: handleNextPage })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $2634b67aa7c4350a$var$styles.rightNavigationStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        spacing: "compact",
        onClick: handleNextPage,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        label: intl.formatMessage((0, $jFWFL.messages).rightNavigateLabel),
        isTooltipDisabled: false
    }));
};
const $2634b67aa7c4350a$export$6c6a0fee39bccb13 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { totalReactionsCount: totalReactionsCount, handlePreviousPage: handlePreviousPage, handleNextPage: handleNextPage, currentPage: currentPage, maxPages: maxPages, currentReactions: currentReactions, emojiProvider: emojiProvider, handleCloseReactionsDialog: handleCloseReactionsDialog } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [cache, setCache] = (0, $cozmU.useState)(t1);
    const { titleId: titleId } = (0, $aGB72.useModal)();
    const intl = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const isSinglePage = maxPages === 1;
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === maxPages;
    let t2;
    if ($[1] !== cache || $[2] !== emojiProvider) {
        t2 = (reaction)=>{
            const { emojiId: emojiId } = reaction;
            if (!emojiId || cache[emojiId]) return;
            (async ()=>{
                const provider = await emojiProvider;
                const emoji = await provider.findByEmojiId({
                    shortName: "",
                    id: emojiId
                });
                if (emoji?.name) {
                    const capitalizedName = emoji.name.replace(/\b\w/g, $2634b67aa7c4350a$var$_temp3);
                    setCache((prevCache)=>({
                            ...prevCache,
                            [emojiId]: capitalizedName
                        }));
                }
            })();
        };
        $[1] = cache;
        $[2] = emojiProvider;
        $[3] = t2;
    } else t2 = $[3];
    const handleMouseEnter = t2;
    let t3;
    if ($[4] !== intl || $[5] !== totalReactionsCount) {
        t3 = intl.formatMessage((0, $jFWFL.messages).reactionsCount, {
            count: totalReactionsCount
        });
        $[4] = intl;
        $[5] = totalReactionsCount;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3 || $[8] !== titleId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "medium",
            id: titleId
        }, t3);
        $[7] = t3;
        $[8] = titleId;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== handleCloseReactionsDialog) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
            onClick: handleCloseReactionsDialog
        });
        $[10] = handleCloseReactionsDialog;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t4 || $[13] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $2634b67aa7c4350a$var$styles.fullWidthStyle
        }, t4, t5);
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _1x1D3gOeNX _3iDTPbQ4SZ _39xV02N91d _0hPCNLchRC _0wPZYW2ADO _1QQliJ7dHp _2DRTKujOvk"
        ]);
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== handlePreviousPage || $[17] !== isOnFirstPage || $[18] !== isSinglePage) {
        t8 = !isSinglePage && !isOnFirstPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$LeftNavigationButton, {
            handlePreviousPage: handlePreviousPage
        });
        $[16] = handlePreviousPage;
        $[17] = isOnFirstPage;
        $[18] = isSinglePage;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== cache || $[21] !== colorMode || $[22] !== currentReactions || $[23] !== emojiProvider || $[24] !== handleMouseEnter) {
        let t10;
        if ($[26] !== cache || $[27] !== colorMode || $[28] !== emojiProvider || $[29] !== handleMouseEnter) {
            t10 = (reaction_0, index)=>{
                const emojiId_0 = {
                    id: reaction_0.emojiId,
                    shortName: ""
                };
                return /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        $2634b67aa7c4350a$var$customTabWrapper.base,
                        colorMode === "dark" && $2634b67aa7c4350a$var$customTabWrapper.darkTheme,
                        index === 0 && "_2Zuz6Q5zaO",
                        "reaction-elements"
                    ]),
                    key: reaction_0.emojiId,
                    "data-testid": emojiId_0?.id,
                    onMouseEnter: ()=>{
                        handleMouseEnter(reaction_0);
                    },
                    onFocus: (0, $iDrrr.fg)("platform_suppression_removal_fix_reactions") ? ()=>{
                        handleMouseEnter(reaction_0);
                    } : undefined
                }, /*#__PURE__*/ $cozmU.createElement((0, $bxtKM.default), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                    content: cache[reaction_0.emojiId],
                    canAppear: ()=>!!cache[reaction_0.emojiId]
                }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                    justifyContent: "center",
                    alignItems: "center",
                    direction: "row"
                }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $2634b67aa7c4350a$var$styles.emoji
                }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
                    emojiProvider: emojiProvider,
                    emojiId: emojiId_0,
                    fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
                    showTooltip: true
                })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $2634b67aa7c4350a$var$styles.counterStyle
                }, /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
                    value: reaction_0.count
                }))))));
            };
            $[26] = cache;
            $[27] = colorMode;
            $[28] = emojiProvider;
            $[29] = handleMouseEnter;
            $[30] = t10;
        } else t10 = $[30];
        t9 = currentReactions.map(t10);
        $[20] = cache;
        $[21] = colorMode;
        $[22] = currentReactions;
        $[23] = emojiProvider;
        $[24] = handleMouseEnter;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[31] !== handleNextPage || $[32] !== isOnLastPage || $[33] !== isSinglePage) {
        t10 = !isSinglePage && !isOnLastPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$RightNavigationButton, {
            handleNextPage: handleNextPage
        });
        $[31] = handleNextPage;
        $[32] = isOnLastPage;
        $[33] = isSinglePage;
        $[34] = t10;
    } else t10 = $[34];
    let t11;
    if ($[35] !== t10 || $[36] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, t9, t10);
        $[35] = t10;
        $[36] = t9;
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== t11 || $[39] !== t8) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement("div", {
            id: "reactions-dialog-tabs-list",
            className: t7
        }, t8, t11));
        $[38] = t11;
        $[39] = t8;
        $[40] = t12;
    } else t12 = $[40];
    let t13;
    if ($[41] !== t12 || $[42] !== t6) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, t6, t12);
        $[41] = t12;
        $[42] = t6;
        $[43] = t13;
    } else t13 = $[43];
    return t13;
} : ({ totalReactionsCount: totalReactionsCount, handlePreviousPage: handlePreviousPage, handleNextPage: handleNextPage, currentPage: currentPage, maxPages: maxPages, currentReactions: currentReactions, emojiProvider: emojiProvider, handleCloseReactionsDialog: handleCloseReactionsDialog })=>{
    const [cache, setCache] = (0, $cozmU.useState)({});
    const { titleId: titleId } = (0, $aGB72.useModal)();
    const intl = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const isSinglePage = maxPages === 1;
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === maxPages;
    const handleMouseEnter = (reaction)=>{
        const { emojiId: emojiId } = reaction;
        if (!emojiId || cache[emojiId]) return;
        (async ()=>{
            // Note: not a network request e.g. ReactedUsersQuery
            const provider = await emojiProvider;
            const emoji = await provider.findByEmojiId({
                shortName: '',
                id: emojiId
            });
            if (emoji?.name) {
                // capitalize first letter of each string
                const capitalizedName = emoji.name.replace(/\b\w/g, (char)=>char.toUpperCase());
                setCache((prevCache)=>({
                        ...prevCache,
                        [emojiId]: capitalizedName
                    }));
            }
        })();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $2634b67aa7c4350a$var$styles.fullWidthStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "medium",
        id: titleId
    }, intl.formatMessage((0, $jFWFL.messages).reactionsCount, {
        count: totalReactionsCount
    })), /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
        onClick: handleCloseReactionsDialog
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement("div", {
        id: "reactions-dialog-tabs-list",
        className: (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _1x1D3gOeNX _3iDTPbQ4SZ _39xV02N91d _0hPCNLchRC _0wPZYW2ADO _1QQliJ7dHp _2DRTKujOvk"
        ])
    }, !isSinglePage && !isOnFirstPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$LeftNavigationButton, {
        handlePreviousPage: handlePreviousPage
    }), /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, currentReactions.map((reaction_0, index)=>{
        const emojiId_0 = {
            id: reaction_0.emojiId,
            shortName: ''
        };
        return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $2634b67aa7c4350a$var$customTabWrapper.base,
                colorMode === 'dark' && $2634b67aa7c4350a$var$customTabWrapper.darkTheme,
                index === 0 && "_2Zuz6Q5zaO",
                "reaction-elements"
            ]),
            key: reaction_0.emojiId,
            "data-testid": emojiId_0?.id,
            onMouseEnter: ()=>{
                handleMouseEnter(reaction_0);
            },
            onFocus: (0, $iDrrr.fg)('platform_suppression_removal_fix_reactions') ? ()=>{
                handleMouseEnter(reaction_0);
            } : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $bxtKM.default), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: cache[reaction_0.emojiId],
            canAppear: ()=>!!cache[reaction_0.emojiId]
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            alignItems: "center",
            direction: "row"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2634b67aa7c4350a$var$styles.emoji
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId_0,
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            showTooltip: true
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2634b67aa7c4350a$var$styles.counterStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
            value: reaction_0.count
        }))))));
    }), !isSinglePage && !isOnLastPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$RightNavigationButton, {
        handleNextPage: handleNextPage
    })))));
};
function $2634b67aa7c4350a$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps,
        size: "small"
    });
}
function $2634b67aa7c4350a$var$_temp2(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps,
        size: "small"
    });
}
function $2634b67aa7c4350a$var$_temp3(char) {
    return char.toUpperCase();
}


const $6c371858ccc38d3c$var$styles = {
    modalBodyStyle: "_1DCdHiNHnM"
}; /* Reactions Container. Using pseudo Element :after to set border since with onClick of Reaction to higlight the
   border blue below the reaction. */ 
const $6c371858ccc38d3c$var$containerStyle = null; /**
                              * Test id for the Reactions modal dialog
                              */ 
const $6c371858ccc38d3c$export$ef88759cddab4775 = 'render-reactions-modal';
const $6c371858ccc38d3c$export$df84a24235404de6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { reactions: t1, handleCloseReactionsDialog: t2, emojiProvider: emojiProvider, selectedEmojiId: selectedEmojiId, handleSelectReaction: t3, handlePaginationChange: t4, ProfileCardWrapper: ProfileCardWrapper } = t0;
    let t5;
    if ($[0] !== t1) {
        t5 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t5;
    } else t5 = $[1];
    const reactions = t5;
    const handleCloseReactionsDialog = t2 === undefined ? $6c371858ccc38d3c$var$_temp : t2;
    const handleSelectReaction = t3 === undefined ? $6c371858ccc38d3c$var$_temp2 : t3;
    const handlePaginationChange = t4 === undefined ? $6c371858ccc38d3c$var$_temp3 : t4;
    const [hasNavigatedPages, setHasNavigatedPages] = (0, $cozmU.useState)(false);
    const [currentPage, setCurrentPage] = (0, $cozmU.useState)(1);
    let t6;
    if ($[2] !== reactions) {
        t6 = reactions.reduce($6c371858ccc38d3c$var$_temp4, 0);
        $[2] = reactions;
        $[3] = t6;
    } else t6 = $[3];
    const totalReactionsCount = t6;
    const maxPages = Math.max(1, Math.ceil(reactions.length / (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY)));
    const start = (currentPage - 1) * (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
    const end = start + (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
    let t7;
    if ($[4] !== end || $[5] !== reactions || $[6] !== start) {
        t7 = reactions.slice(start, end);
        $[4] = end;
        $[5] = reactions;
        $[6] = start;
        $[7] = t7;
    } else t7 = $[7];
    const currentReactions = t7;
    let t8;
    if ($[8] !== maxPages) {
        t8 = ()=>{
            setCurrentPage((prevPage)=>Math.min(prevPage + 1, maxPages));
            setHasNavigatedPages(true);
        };
        $[8] = maxPages;
        $[9] = t8;
    } else t8 = $[9];
    const handleNextPage = t8;
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            setCurrentPage($6c371858ccc38d3c$var$_temp5);
            setHasNavigatedPages(true);
        };
        $[10] = t9;
    } else t9 = $[10];
    const handlePreviousPage = t9;
    const firstEmojiOnPage = currentReactions[0]?.emojiId;
    let t10;
    let t11;
    if ($[11] !== currentPage || $[12] !== firstEmojiOnPage || $[13] !== handlePaginationChange || $[14] !== hasNavigatedPages || $[15] !== maxPages) {
        t10 = ()=>{
            if (hasNavigatedPages && firstEmojiOnPage) handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
        };
        t11 = [
            hasNavigatedPages,
            currentPage,
            maxPages,
            firstEmojiOnPage,
            handlePaginationChange
        ];
        $[11] = currentPage;
        $[12] = firstEmojiOnPage;
        $[13] = handlePaginationChange;
        $[14] = hasNavigatedPages;
        $[15] = maxPages;
        $[16] = t10;
        $[17] = t11;
    } else {
        t10 = $[16];
        t11 = $[17];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[18] !== currentReactions || $[19] !== selectedEmojiId) {
        let t13;
        if ($[21] !== selectedEmojiId) {
            t13 = (reaction)=>reaction.emojiId === selectedEmojiId;
            $[21] = selectedEmojiId;
            $[22] = t13;
        } else t13 = $[22];
        t12 = currentReactions.findIndex(t13);
        $[18] = currentReactions;
        $[19] = selectedEmojiId;
        $[20] = t12;
    } else t12 = $[20];
    const selectedIndex = t12;
    let t13;
    if ($[23] !== currentReactions || $[24] !== handleSelectReaction || $[25] !== selectedIndex) {
        t13 = (index)=>{
            if (index === selectedIndex) return;
            const emojiId = currentReactions[index].emojiId;
            handleSelectReaction(emojiId);
        };
        $[23] = currentReactions;
        $[24] = handleSelectReaction;
        $[25] = selectedIndex;
        $[26] = t13;
    } else t13 = $[26];
    const onTabChange = t13;
    let t14;
    if ($[27] !== currentPage || $[28] !== currentReactions || $[29] !== emojiProvider || $[30] !== handleCloseReactionsDialog || $[31] !== handleNextPage || $[32] !== maxPages || $[33] !== totalReactionsCount) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $2634b67aa7c4350a$export$6c6a0fee39bccb13), {
            totalReactionsCount: totalReactionsCount,
            maxPages: maxPages,
            handlePreviousPage: handlePreviousPage,
            handleNextPage: handleNextPage,
            currentPage: currentPage,
            emojiProvider: emojiProvider,
            currentReactions: currentReactions,
            handleCloseReactionsDialog: handleCloseReactionsDialog
        });
        $[27] = currentPage;
        $[28] = currentReactions;
        $[29] = emojiProvider;
        $[30] = handleCloseReactionsDialog;
        $[31] = handleNextPage;
        $[32] = maxPages;
        $[33] = totalReactionsCount;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _3iDTPbQ4SZ _37wbyu7p2s _1mT5xdRAKS _3h2tDz3EvU _0GBAIrogpp _39mJBjdnbC _4Gb5FivLZJ _4DX2ezN91d _4zi1EpdnbC _2WYcYGWVPG"
        ]);
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== ProfileCardWrapper || $[37] !== currentReactions || $[38] !== selectedEmojiId) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6c371858ccc38d3c$var$styles.modalBodyStyle
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t15
        }, /*#__PURE__*/ $cozmU.createElement((0, $28b3de9cab4acb5c$export$a87089fe362b9d93), {
            selectedEmojiId: selectedEmojiId,
            reactions: currentReactions,
            ProfileCardWrapper: ProfileCardWrapper
        }))));
        $[36] = ProfileCardWrapper;
        $[37] = currentReactions;
        $[38] = selectedEmojiId;
        $[39] = t16;
    } else t16 = $[39];
    let t17;
    if ($[40] !== onTabChange || $[41] !== selectedIndex || $[42] !== t14 || $[43] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
            id: "reactions-dialog-tabs",
            onChange: onTabChange,
            selected: selectedIndex
        }, t14, t16);
        $[40] = onTabChange;
        $[41] = selectedIndex;
        $[42] = t14;
        $[43] = t16;
        $[44] = t17;
    } else t17 = $[44];
    let t18;
    if ($[45] !== handleCloseReactionsDialog || $[46] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: handleCloseReactionsDialog,
            height: 600,
            testId: $6c371858ccc38d3c$export$ef88759cddab4775
        }, t17);
        $[45] = handleCloseReactionsDialog;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    return t18;
} : ({ reactions: reactions = [], handleCloseReactionsDialog: handleCloseReactionsDialog = ()=>{}, emojiProvider: emojiProvider, selectedEmojiId: selectedEmojiId, handleSelectReaction: handleSelectReaction = ()=>{}, handlePaginationChange: handlePaginationChange = ()=>{}, ProfileCardWrapper: ProfileCardWrapper })=>{
    const [hasNavigatedPages, setHasNavigatedPages] = (0, $cozmU.useState)(false);
    const [currentPage, setCurrentPage] = (0, $cozmU.useState)(1);
    const totalReactionsCount = (0, $cozmU.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count;
        }, 0);
    }, [
        reactions
    ]);
    const maxPages = Math.max(1, Math.ceil(reactions.length / (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY)));
    const currentReactions = (0, $cozmU.useMemo)(()=>{
        const start = (currentPage - 1) * (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
        const end = start + (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
        return reactions.slice(start, end);
    }, [
        reactions,
        currentPage
    ]);
    const handleNextPage = ()=>{
        setCurrentPage((prevPage)=>Math.min(prevPage + 1, maxPages));
        setHasNavigatedPages(true);
    };
    const handlePreviousPage = ()=>{
        setCurrentPage((prevPage_0)=>Math.max(prevPage_0 - 1, 1));
        setHasNavigatedPages(true);
    };
    const firstEmojiOnPage = currentReactions[0]?.emojiId;
    (0, $cozmU.useEffect)(()=>{
        // trigger the handler with the first emoji when the page changes
        if (hasNavigatedPages && firstEmojiOnPage) handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
    }, [
        hasNavigatedPages,
        currentPage,
        maxPages,
        firstEmojiOnPage,
        handlePaginationChange
    ]);
    const selectedIndex = currentReactions.findIndex((reaction)=>reaction.emojiId === selectedEmojiId);
    const onTabChange = (0, $cozmU.useCallback)((index)=>{
        if (index === selectedIndex) return;
        const emojiId = currentReactions[index].emojiId;
        handleSelectReaction(emojiId);
    }, [
        selectedIndex,
        currentReactions,
        handleSelectReaction
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: handleCloseReactionsDialog,
        height: 600,
        testId: $6c371858ccc38d3c$export$ef88759cddab4775
    }, /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
        id: "reactions-dialog-tabs",
        onChange: onTabChange,
        selected: selectedIndex
    }, /*#__PURE__*/ $cozmU.createElement((0, $2634b67aa7c4350a$export$6c6a0fee39bccb13), {
        totalReactionsCount: totalReactionsCount,
        maxPages: maxPages,
        handlePreviousPage: handlePreviousPage,
        handleNextPage: handleNextPage,
        currentPage: currentPage,
        emojiProvider: emojiProvider,
        currentReactions: currentReactions,
        handleCloseReactionsDialog: handleCloseReactionsDialog
    }), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6c371858ccc38d3c$var$styles.modalBodyStyle
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _3iDTPbQ4SZ _37wbyu7p2s _1mT5xdRAKS _3h2tDz3EvU _0GBAIrogpp _39mJBjdnbC _4Gb5FivLZJ _4DX2ezN91d _4zi1EpdnbC _2WYcYGWVPG"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $28b3de9cab4acb5c$export$a87089fe362b9d93), {
        selectedEmojiId: selectedEmojiId,
        reactions: currentReactions,
        ProfileCardWrapper: ProfileCardWrapper
    }))))));
};
function $6c371858ccc38d3c$var$_temp() {}
function $6c371858ccc38d3c$var$_temp2() {}
function $6c371858ccc38d3c$var$_temp3() {}
function $6c371858ccc38d3c$var$_temp4(accum, current) {
    accum = accum + current?.count;
    return accum;
}
function $6c371858ccc38d3c$var$_temp5(prevPage_0) {
    return Math.max(prevPage_0 - 1, 1);
}


















var $af2XZ = parcelRequire("af2XZ");





var $akErP = parcelRequire("akErP");


var $lQV5m = parcelRequire("lQV5m");


var $kN1yU = parcelRequire("kN1yU");


var $jp2Q3 = parcelRequire("jp2Q3");
















const $cd2f8ae127029e1f$export$92dae2778ae88f9d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCloseManager(ref, callback, t0, t1) {
    const $ = (0, $bDgLe.c)(6);
    const useCapture = t0 === undefined ? false : t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== callback || $[1] !== enabled || $[2] !== ref || $[3] !== useCapture) {
        t2 = ()=>{
            if (!enabled) return;
            const handleClickOutside = function handleClickOutside(event) {
                if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) callback("CLICK_OUTSIDE");
            };
            const handleKeydown = function handleKeydown(event_0) {
                const { key: key } = event_0;
                if (key === "Escape" || key === "Esc") callback("ESCAPE");
            };
            document.addEventListener("click", handleClickOutside, useCapture);
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("click", handleClickOutside, useCapture);
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        t3 = [
            ref,
            callback,
            useCapture,
            enabled
        ];
        $[0] = callback;
        $[1] = enabled;
        $[2] = ref;
        $[3] = useCapture;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useCloseManager(ref, callback, useCapture = false, enabled = true) {
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        /**
     * Alert if clicked on outside of element
     */ function handleClickOutside(event) {
            if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event_0) {
            const { key: key } = event_0;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        ref,
        callback,
        useCapture,
        enabled
    ]);
};
const $cd2f8ae127029e1f$export$d6c3c92a8b7167c2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCloseManagerV2(popupRef, triggerRef, callback, t0, t1) {
    const $ = (0, $bDgLe.c)(7);
    const useCapture = t0 === undefined ? false : t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== callback || $[1] !== enabled || $[2] !== popupRef || $[3] !== triggerRef || $[4] !== useCapture) {
        t2 = ()=>{
            if (!enabled) return;
            const handleClickOutside = function handleClickOutside(event) {
                const target = event.target;
                const isClickOnPopup = popupRef && popupRef.contains(target);
                const isClickOnTrigger = triggerRef && triggerRef.contains(target);
                if (!isClickOnPopup && !isClickOnTrigger) callback("CLICK_OUTSIDE");
            };
            const handleKeydown = function handleKeydown(event_0) {
                const { key: key } = event_0;
                if (key === "Escape" || key === "Esc") callback("ESCAPE");
            };
            document.addEventListener("click", handleClickOutside, useCapture);
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("click", handleClickOutside, useCapture);
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        t3 = [
            triggerRef,
            popupRef,
            callback,
            useCapture,
            enabled
        ];
        $[0] = callback;
        $[1] = enabled;
        $[2] = popupRef;
        $[3] = triggerRef;
        $[4] = useCapture;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useCloseManagerV2(popupRef, triggerRef, callback, useCapture = false, enabled = true) {
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        /**
     * Alert if clicked on outside of element
     */ function handleClickOutside(event) {
            const target = event.target;
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event_0) {
            const { key: key } = event_0;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        triggerRef,
        popupRef,
        callback,
        useCapture,
        enabled
    ]);
};











const $ca45144c595c321e$export$94d25041dfc7e5be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (initialState, delay)=>{
    const $ = (0, $bDgLe.c)(7);
    const [state, setState] = (0, $cozmU.useState)(initialState);
    const timeoutRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== delay) {
        t2 = (newState, t3)=>{
            const immediate = t3 === undefined ? false : t3;
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (immediate || delay === 0) setState(newState);
            else timeoutRef.current = setTimeout(()=>{
                setState(newState);
            }, delay);
        };
        $[2] = delay;
        $[3] = t2;
    } else t2 = $[3];
    const handleDelayedStateChange = t2;
    let t3;
    if ($[4] !== handleDelayedStateChange || $[5] !== state) {
        t3 = [
            state,
            handleDelayedStateChange
        ];
        $[4] = handleDelayedStateChange;
        $[5] = state;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : (initialState, delay)=>{
    const [state, setState] = (0, $cozmU.useState)(initialState);
    const timeoutRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleDelayedStateChange = (0, $cozmU.useCallback)((newState, immediate = false)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (immediate || delay === 0) setState(newState);
        else timeoutRef.current = setTimeout(()=>{
            setState(newState);
        }, delay);
    }, [
        delay
    ]);
    return [
        state,
        handleDelayedStateChange
    ];
};












var $dlU1V = parcelRequire("dlU1V");

const $6cb1a3d2db6a68e4$export$5562a1f223a0d314 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { targetRef: targetRef, initialFocusRef: initialFocusRef } = t0;
    let t1;
    let t2;
    if ($[0] !== initialFocusRef || $[1] !== targetRef) {
        t1 = ()=>{
            if (!targetRef) return;
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: initialFocusRef || targetRef,
                fallbackFocus: targetRef,
                returnFocusOnDeactivate: false
            };
            const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($dlU1V)))(targetRef, trapConfig);
            let frameId = requestAnimationFrame(()=>{
                frameId = null;
                focusTrap.activate();
            });
            return ()=>{
                if (frameId != null) {
                    cancelAnimationFrame(frameId);
                    frameId = null;
                }
                focusTrap.deactivate();
            };
        };
        t2 = [
            targetRef,
            initialFocusRef
        ];
        $[0] = initialFocusRef;
        $[1] = targetRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ targetRef: targetRef, initialFocusRef: initialFocusRef })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: false
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($dlU1V)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef,
        initialFocusRef
    ]);
};





















var $ieeJu = parcelRequire("ieeJu");


var $4o0zT = parcelRequire("4o0zT");































var $l4yrE = parcelRequire("l4yrE");




var $cXtTj = parcelRequire("cXtTj");








var $3TY4f = parcelRequire("3TY4f");





var $hBYtq = parcelRequire("hBYtq");

const $a824af7beab19c72$var$styles = {
    emojiButton: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0bjKvDKxmn _2V7sgOdnbC _3iDTPbQ4SZ _0KLXru66of _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _1B4rbIOsGf _3NJLv8keKm",
    hoverableReactionPickerSelectorEmojiButton: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0yKXXaDGiX _0Of8r2FQfX _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _0KLXru66of _1UtDYzZpcK _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _1eOmH6o126 _3gzVzLN4oS",
    hoverableReactionPickerSelectorEmojiButtonMotion: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0bjKvDKxmn _23rrnHyKLB _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0yKXXaDGiX _0Of8r2FQfX _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _0KLXru66of _1UtDYzZpcK _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS",
    emojiSlot: "_4ouGXISPN1",
    hoverableReactionPickerSelectorEmojiSlot: "_4ouGXIey7F"
};
const $a824af7beab19c72$export$116e2ec39db7c58e = 'button-emoji-id';
const $a824af7beab19c72$export$c42b68175913d473 = 'button-emoji-slot-id';
const $a824af7beab19c72$export$e6ce3311a4d41b7f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { emojiId: emojiId, onClick: onClick, emojiProvider: emojiProvider, hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelectorEmoji } = t0;
    let t1;
    if ($[0] !== emojiId || $[1] !== onClick) {
        t1 = (event)=>{
            event.preventDefault();
            if (onClick && (0, $3TY4f.isLeftClick)(event)) onClick(emojiId, undefined, event);
        };
        $[0] = emojiId;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onButtonClick = t1;
    const intl = (0, $kSwu1.useIntl)();
    const emojiHeight = hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : (0, $l4yrE.defaultEmojiHeight);
    const t2 = hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : undefined;
    let t3;
    if ($[3] !== emojiId || $[4] !== emojiProvider || $[5] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: t2
        });
        $[3] = emojiId;
        $[4] = emojiProvider;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const emoji = t3;
    let t4;
    if ($[7] !== emojiHeight || $[8] !== emojiId || $[9] !== emojiProvider || $[10] !== hoverableReactionPickerSelectorEmoji) {
        t4 = hoverableReactionPickerSelectorEmoji ? /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": $a824af7beab19c72$export$c42b68175913d473,
            className: (0, $hekY6.default)([
                $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiSlot
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: emojiHeight
        })) : /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": $a824af7beab19c72$export$c42b68175913d473,
            className: (0, $hekY6.default)([
                $a824af7beab19c72$var$styles.emojiSlot
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: emojiHeight
        }));
        $[7] = emojiHeight;
        $[8] = emojiId;
        $[9] = emojiProvider;
        $[10] = hoverableReactionPickerSelectorEmoji;
        $[11] = t4;
    } else t4 = $[11];
    const reservedEmoji = t4;
    let t5;
    if ($[12] !== emojiId.shortName || $[13] !== intl) {
        t5 = intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
            emoji: emojiId.shortName
        });
        $[12] = emojiId.shortName;
        $[13] = intl;
        $[14] = t5;
    } else t5 = $[14];
    const t6 = hoverableReactionPickerSelectorEmoji ? (0, $iDrrr.fg)("platform-dst-motion-uplift-custom-button") ? $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiButtonMotion : $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiButton : $a824af7beab19c72$var$styles.emojiButton;
    let t7;
    if ($[15] !== emoji || $[16] !== reservedEmoji) {
        t7 = (0, $cXtTj.default).getExperimentValue("platform_teamoji_26_refresh_emoji_picker", "isEnabled", false) ? reservedEmoji : emoji;
        $[15] = emoji;
        $[16] = reservedEmoji;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== onButtonClick || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            testId: $a824af7beab19c72$export$116e2ec39db7c58e,
            onClick: onButtonClick,
            "aria-label": t5,
            xcss: t6
        }, t7);
        $[18] = onButtonClick;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ emojiId: emojiId, onClick: onClick, emojiProvider: emojiProvider, hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelectorEmoji })=>{
    const onButtonClick = (event)=>{
        event.preventDefault();
        if (onClick && (0, $3TY4f.isLeftClick)(event)) onClick(emojiId, undefined, event);
    };
    const intl = (0, $kSwu1.useIntl)();
    const emojiHeight = hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : (0, $l4yrE.defaultEmojiHeight);
    const emoji = /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : undefined
    });
    const reservedEmoji = hoverableReactionPickerSelectorEmoji ? /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": $a824af7beab19c72$export$c42b68175913d473,
        className: (0, $hekY6.default)([
            $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiSlot
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: emojiHeight
    })) : /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": $a824af7beab19c72$export$c42b68175913d473,
        className: (0, $hekY6.default)([
            $a824af7beab19c72$var$styles.emojiSlot
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: emojiHeight
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        testId: $a824af7beab19c72$export$116e2ec39db7c58e,
        onClick: onButtonClick,
        "aria-label": intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
            emoji: emojiId.shortName
        }),
        xcss: hoverableReactionPickerSelectorEmoji ? (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') ? $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiButtonMotion : $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiButton : $a824af7beab19c72$var$styles.emojiButton
    }, (0, $cXtTj.default).getExperimentValue('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', false) ? reservedEmoji : emoji);
};


















var $6TaGl = parcelRequire("6TaGl");







const $a5eeba0f96f1fb4c$export$3b6c19440cd8324b = 'show-more-button';
const $a5eeba0f96f1fb4c$export$ca7697601dcd7803 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).moreEmoji, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: message
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                label: message,
                onClick: onClick,
                testId: $a5eeba0f96f1fb4c$export$3b6c19440cd8324b,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                appearance: "subtle"
            })));
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).moreEmoji, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            label: message,
            onClick: onClick,
            testId: $a5eeba0f96f1fb4c$export$3b6c19440cd8324b,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
            appearance: "subtle"
        })));
};


















var $b35Wv = parcelRequire("b35Wv");










var $k12R1 = parcelRequire("k12R1");




const $5a2af3b1f8e184d8$var$styles = {
    trigger: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _4ouGXIUofl _0jFU0VoWWg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    subtleTrigger: "_3hxITiYbGa _4ouGXIoWWg",
    expandedTrigger: "_4ouGXIoV4E",
    triggerStylesRefresh: "_0bjKvDKxmn",
    transparentEnabledTrigger: "_3vBAKH9r67 _0KLXru66of _1eOmH6o126 _3gzVzLN4oS",
    opaqueEnabledTrigger: "_3vBAKH9r67 _0KLXrulfZc _1eOmH6d1Zr _3gzVzLJNoT",
    disabledTrigger: "_3vBAKHhQC5 _0KLXruVrZW",
    miniMode: "_0bjKvDKxmn _3hxITiYbGa _4ouGXIoWWg _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    fullWidthSummaryViewReactionPickerTrigger: "_39xV02N91d _0Of8r22ADO _2Zuz6Q2ADO _1Znuxb2ADO",
    fullWidthSelectorTrayReactionPickerTrigger: "_39xV02N91d _0Of8r21Y8M _2Zuz6Q1Y8M _1Znuxb1Y8M",
    fullWidth: "_39xV02N91d _1EqgXl5R67"
};
const $5a2af3b1f8e184d8$export$456835f64b911ea5 = 'render-tooltip-trigger';
const $5a2af3b1f8e184d8$export$4397a1ddb3e8d706 = 'render-trigger-button';
const $5a2af3b1f8e184d8$export$361f8ee5961b2075 = 'render-trigger-container';
const $5a2af3b1f8e184d8$export$2243b1861b17bb3b = 'render-list-item-wrapper';
const $5a2af3b1f8e184d8$var$i18n = (0, $kSwu1.defineMessages)({
    addReaction: {
        id: "reaction-picker-trigger.add.reaction.message",
        defaultMessage: "Add a reaction"
    }
});
const $5a2af3b1f8e184d8$var$addReactionStyles = {
    addReactionMessage: "_2sNsIg7NXe _1UtDYzZpcK _2XsHFM1Y8M"
};
const $5a2af3b1f8e184d8$var$noMarkerListStyle = null; /**
                                 * Render an emoji button to open the reactions select picker
                                 */ 
const $5a2af3b1f8e184d8$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(48);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onClick: onClick, miniMode: miniMode, tooltipContent: tooltipContent, disabled: t0, ariaAttributes: t1, showOpaqueBackground: t2, showAddReactionText: t3, subtleReactionsSummaryAndPicker: t4, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: t5, fullWidthSummaryViewReactionPickerTrigger: t6, isListItem: t7, fullWidthSelectorTrayReactionPickerTrigger: t8, emojiPickerSize: emojiPickerSize } = props;
    const disabled = t0 === undefined ? false : t0;
    let t9;
    if ($[0] !== t1) {
        t9 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t9;
    } else t9 = $[1];
    const ariaAttributes = t9;
    const showOpaqueBackground = t2 === undefined ? false : t2;
    const showAddReactionText = t3 === undefined ? false : t3;
    const subtleReactionsSummaryAndPicker = t4 === undefined ? false : t4;
    let t10;
    if ($[2] !== formatMessage || $[3] !== t5) {
        t10 = t5 === undefined ? formatMessage($5a2af3b1f8e184d8$var$i18n.addReaction) : t5;
        $[2] = formatMessage;
        $[3] = t5;
        $[4] = t10;
    } else t10 = $[4];
    const reactionPickerTriggerText = t10;
    const fullWidthSummaryViewReactionPickerTrigger = t6 === undefined ? false : t6;
    const isListItem = t7 === undefined ? false : t7;
    const fullWidthSelectorTrayReactionPickerTrigger = t8 === undefined ? false : t8;
    let t11;
    if ($[5] !== disabled || $[6] !== onClick) {
        t11 = (e, analyticsEvent)=>{
            if (onClick && !disabled) onClick(e, analyticsEvent);
        };
        $[5] = disabled;
        $[6] = onClick;
        $[7] = t11;
    } else t11 = $[7];
    const handleMouseDown = t11;
    let T0;
    let T1;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    if ($[8] !== ariaAttributes || $[9] !== disabled || $[10] !== emojiPickerSize || $[11] !== formatMessage || $[12] !== fullWidthSelectorTrayReactionPickerTrigger || $[13] !== fullWidthSummaryViewReactionPickerTrigger || $[14] !== handleMouseDown || $[15] !== isListItem || $[16] !== miniMode || $[17] !== reactionPickerTriggerIcon || $[18] !== reactionPickerTriggerText || $[19] !== ref || $[20] !== showAddReactionText || $[21] !== showOpaqueBackground || $[22] !== subtleReactionsSummaryAndPicker || $[23] !== tooltipContent) {
        const renderPressableButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                testId: $5a2af3b1f8e184d8$export$4397a1ddb3e8d706,
                xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$styles.trigger, (fullWidthSummaryViewReactionPickerTrigger || fullWidthSelectorTrayReactionPickerTrigger) && $5a2af3b1f8e184d8$var$styles.fullWidth, subtleReactionsSummaryAndPicker && $5a2af3b1f8e184d8$var$styles.subtleTrigger, showAddReactionText && $5a2af3b1f8e184d8$var$styles.expandedTrigger, disabled ? $5a2af3b1f8e184d8$var$styles.disabledTrigger : showOpaqueBackground ? $5a2af3b1f8e184d8$var$styles.opaqueEnabledTrigger : $5a2af3b1f8e184d8$var$styles.transparentEnabledTrigger, miniMode && $5a2af3b1f8e184d8$var$styles.miniMode, (0, $iDrrr.fg)("platform-component-visual-refresh") && $5a2af3b1f8e184d8$var$styles.triggerStylesRefresh),
                style: {
                    lineHeight: "16px"
                },
                onClick: handleMouseDown,
                isDisabled: disabled,
                ref: ref,
                "data-subtle": subtleReactionsSummaryAndPicker,
                "data-mini-mode": miniMode,
                ...ariaAttributes
            }, !!reactionPickerTriggerIcon ? reactionPickerTriggerIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
                testId: "emoji-add-icon",
                color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)",
                label: (0, $iDrrr.fg)("tef_fix_a11y_add_reaction_button_language_support") ? formatMessage($5a2af3b1f8e184d8$var$i18n.addReaction) : "Add reaction",
                "aria-hidden": true,
                size: emojiPickerSize === "small" ? "small" : "medium"
            }), showAddReactionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$addReactionStyles.addReactionMessage)
            }, reactionPickerTriggerText));
        T1 = (0, $iMnC5.Box);
        const t18 = fullWidthSummaryViewReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSummaryViewReactionPickerTrigger;
        const t19 = fullWidthSelectorTrayReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSelectorTrayReactionPickerTrigger;
        if ($[32] !== t18 || $[33] !== t19) {
            t16 = (0, $k12R1.cx)(t18, t19);
            $[32] = t18;
            $[33] = t19;
            $[34] = t16;
        } else t16 = $[34];
        t17 = $5a2af3b1f8e184d8$export$361f8ee5961b2075;
        T0 = (0, $lpNn5.default);
        t12 = $5a2af3b1f8e184d8$export$456835f64b911ea5;
        t13 = tooltipContent;
        if ($[35] !== showAddReactionText) {
            t14 = ()=>!showAddReactionText;
            $[35] = showAddReactionText;
            $[36] = t14;
        } else t14 = $[36];
        t15 = isListItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            "data-testid": $5a2af3b1f8e184d8$export$2243b1861b17bb3b,
            className: (0, $hekY6.default)([
                "_1LMyvKYbGa"
            ])
        }, renderPressableButton()) : renderPressableButton();
        $[8] = ariaAttributes;
        $[9] = disabled;
        $[10] = emojiPickerSize;
        $[11] = formatMessage;
        $[12] = fullWidthSelectorTrayReactionPickerTrigger;
        $[13] = fullWidthSummaryViewReactionPickerTrigger;
        $[14] = handleMouseDown;
        $[15] = isListItem;
        $[16] = miniMode;
        $[17] = reactionPickerTriggerIcon;
        $[18] = reactionPickerTriggerText;
        $[19] = ref;
        $[20] = showAddReactionText;
        $[21] = showOpaqueBackground;
        $[22] = subtleReactionsSummaryAndPicker;
        $[23] = tooltipContent;
        $[24] = T0;
        $[25] = T1;
        $[26] = t12;
        $[27] = t13;
        $[28] = t14;
        $[29] = t15;
        $[30] = t16;
        $[31] = t17;
    } else {
        T0 = $[24];
        T1 = $[25];
        t12 = $[26];
        t13 = $[27];
        t14 = $[28];
        t15 = $[29];
        t16 = $[30];
        t17 = $[31];
    }
    let t18;
    if ($[37] !== T0 || $[38] !== t12 || $[39] !== t13 || $[40] !== t14 || $[41] !== t15) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            testId: t12,
            content: t13,
            canAppear: t14
        }, t15);
        $[37] = T0;
        $[38] = t12;
        $[39] = t13;
        $[40] = t14;
        $[41] = t15;
        $[42] = t18;
    } else t18 = $[42];
    let t19;
    if ($[43] !== T1 || $[44] !== t16 || $[45] !== t17 || $[46] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            xcss: t16,
            testId: t17
        }, t18);
        $[43] = T1;
        $[44] = t16;
        $[45] = t17;
        $[46] = t18;
        $[47] = t19;
    } else t19 = $[47];
    return t19;
} : (props, ref)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onClick: onClick, miniMode: miniMode, tooltipContent: tooltipContent, disabled: disabled = false, ariaAttributes: ariaAttributes = {}, showOpaqueBackground: showOpaqueBackground = false, showAddReactionText: showAddReactionText = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText = formatMessage($5a2af3b1f8e184d8$var$i18n.addReaction), fullWidthSummaryViewReactionPickerTrigger: fullWidthSummaryViewReactionPickerTrigger = false, isListItem: isListItem = false, fullWidthSelectorTrayReactionPickerTrigger: fullWidthSelectorTrayReactionPickerTrigger = false, emojiPickerSize: emojiPickerSize } = props;
    const handleMouseDown = (e, analyticsEvent)=>{
        if (onClick && !disabled) onClick(e, analyticsEvent);
    };
    const renderPressableButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            testId: $5a2af3b1f8e184d8$export$4397a1ddb3e8d706,
            xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$styles.trigger, (fullWidthSummaryViewReactionPickerTrigger || fullWidthSelectorTrayReactionPickerTrigger) && $5a2af3b1f8e184d8$var$styles.fullWidth, subtleReactionsSummaryAndPicker && $5a2af3b1f8e184d8$var$styles.subtleTrigger, showAddReactionText && $5a2af3b1f8e184d8$var$styles.expandedTrigger, disabled ? $5a2af3b1f8e184d8$var$styles.disabledTrigger : showOpaqueBackground ? $5a2af3b1f8e184d8$var$styles.opaqueEnabledTrigger : $5a2af3b1f8e184d8$var$styles.transparentEnabledTrigger, miniMode && $5a2af3b1f8e184d8$var$styles.miniMode, (0, $iDrrr.fg)('platform-component-visual-refresh') && $5a2af3b1f8e184d8$var$styles.triggerStylesRefresh),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                lineHeight: '16px'
            },
            onClick: handleMouseDown,
            isDisabled: disabled,
            ref: ref,
            "data-subtle": subtleReactionsSummaryAndPicker,
            "data-mini-mode": miniMode,
            ...ariaAttributes
        }, !!reactionPickerTriggerIcon ? reactionPickerTriggerIcon : // TODO: https://product-fabric.atlassian.net/browse/DSP-21007
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            testId: "emoji-add-icon",
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)",
            label: (0, $iDrrr.fg)('tef_fix_a11y_add_reaction_button_language_support') ? formatMessage($5a2af3b1f8e184d8$var$i18n.addReaction) : 'Add reaction',
            "aria-hidden": true,
            size: emojiPickerSize === 'small' ? 'small' : 'medium'
        }), showAddReactionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$addReactionStyles.addReactionMessage)
        }, reactionPickerTriggerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)(fullWidthSummaryViewReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSummaryViewReactionPickerTrigger, fullWidthSelectorTrayReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSelectorTrayReactionPickerTrigger),
        testId: $5a2af3b1f8e184d8$export$361f8ee5961b2075
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        testId: $5a2af3b1f8e184d8$export$456835f64b911ea5,
        content: tooltipContent,
        canAppear: ()=>!showAddReactionText
    }, isListItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        "data-testid": $5a2af3b1f8e184d8$export$2243b1861b17bb3b,
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa"
        ])
    }, renderPressableButton()) : renderPressableButton()));
});


const $a2ab395c45579380$var$styles = {
    container: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    emojiContainer: "_0aNu0LYbGa _313842Pgdg",
    separator: "_1Vs123NvrM _0obpEh9r67 _421I1o6wH8 _0GTcwR1Y8M _2xTnZx2ADO _0jFU0VoWWg _3iDTPbvbI6",
    hoverableReactionPickerSelectorContainer: "_2mHwu81Y8M _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    hoverableReactionPickerSelectorList: "_2mHwu81Y8M _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0aNu0LYbGa"
};
const $a2ab395c45579380$var$revealAnimation = null;
const $a2ab395c45579380$var$revealStyle = null; /**
                           * Test id for wrapper Selector div
                           */ 
const $a2ab395c45579380$export$fbfb01485b140555 = 'render-selector';
const $a2ab395c45579380$var$Reveal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1gBibyk2o5 _0nFVCGb8VS _43vdfTN8t6 _3Y6bKpgRhm _1YKVNsdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: (0, $ieeJu.expValEquals)("platform_a11y_fixes_reactions_selector_list", "isEnabled", true) ? undefined : "li",
            xcss: $a2ab395c45579380$var$styles.emojiContainer
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            className: t1
        }, children));
        $[1] = children;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: (0, $ieeJu.expValEquals)('platform_a11y_fixes_reactions_selector_list', 'isEnabled', true) ? undefined : 'li',
        xcss: $a2ab395c45579380$var$styles.emojiContainer
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1gBibyk2o5 _0nFVCGb8VS _43vdfTN8t6 _3Y6bKpgRhm _1YKVNsdnbC"
        ])
    }, children));
}; /**
    * Reactions picker panel part of the <ReactionPicker /> component
    */ 
const $a2ab395c45579380$export$d15f4cd5286f9b1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { emojiProvider: emojiProvider, onMoreClick: onMoreClick, onSelection: onSelection, showMore: showMore, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, hoverableReactionPickerSelector: t1 } = t0;
    const hoverableReactionPickerSelector = t1 === undefined ? false : t1;
    const [isTeamojiPickerRefreshEnabled, setIsTeamojiPickerRefreshEnabled] = (0, $cozmU.useState)(false);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsTeamojiPickerRefreshEnabled((0, $ieeJu.expValEquals)("platform_teamoji_26_refresh_emoji_picker", "isEnabled", true));
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== isTeamojiPickerRefreshEnabled || $[3] !== pickerQuickReactionEmojiIds) {
        t4 = pickerQuickReactionEmojiIds ?? (0, $lbdYm.getDefaultReactions)(isTeamojiPickerRefreshEnabled);
        $[2] = isTeamojiPickerRefreshEnabled;
        $[3] = pickerQuickReactionEmojiIds;
        $[4] = t4;
    } else t4 = $[4];
    const quickReactionEmojiIds = t4;
    let t5;
    if ($[5] !== hoverableReactionPickerSelector) {
        t5 = hoverableReactionPickerSelector && (0, $4o0zT.isExperimentEnabled)("platform_a11y_reactions_hover_selector_list");
        $[5] = hoverableReactionPickerSelector;
        $[6] = t5;
    } else t5 = $[6];
    const shouldRenderHoverableReactionPickerSelectorList = t5;
    let t6;
    if ($[7] !== emojiProvider || $[8] !== hoverableReactionPickerSelector || $[9] !== onSelection || $[10] !== shouldRenderHoverableReactionPickerSelectorList) {
        t6 = (emoji, index)=>{
            const emojiButtonAndTooltip = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                key: emoji.id ?? emoji.shortName,
                content: emoji.shortName
            }, /*#__PURE__*/ $cozmU.createElement((0, $a824af7beab19c72$export$e6ce3311a4d41b7f), {
                emojiId: emoji,
                emojiProvider: emojiProvider,
                onClick: onSelection,
                hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelector
            }));
            return hoverableReactionPickerSelector ? shouldRenderHoverableReactionPickerSelectorList ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "li",
                key: emoji.id ?? emoji.shortName,
                xcss: $a2ab395c45579380$var$styles.emojiContainer
            }, emojiButtonAndTooltip) : emojiButtonAndTooltip : /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, {
                key: emoji.id ?? emoji.shortName,
                testId: $a2ab395c45579380$export$fbfb01485b140555
            }, emojiButtonAndTooltip);
        };
        $[7] = emojiProvider;
        $[8] = hoverableReactionPickerSelector;
        $[9] = onSelection;
        $[10] = shouldRenderHoverableReactionPickerSelectorList;
        $[11] = t6;
    } else t6 = $[11];
    const renderEmoji = t6;
    if (hoverableReactionPickerSelector) {
        let t7;
        if ($[12] !== onMoreClick) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $5a2af3b1f8e184d8$export$41fb9f06171c75f4), {
                tooltipContent: (0, $jFWFL.messages).addReaction.defaultMessage,
                onClick: onMoreClick,
                showAddReactionText: true,
                reactionPickerTriggerText: (0, $jFWFL.messages).addNewReaction.defaultMessage,
                fullWidthSelectorTrayReactionPickerTrigger: true
            });
            $[12] = onMoreClick;
            $[13] = t7;
        } else t7 = $[13];
        const t8 = shouldRenderHoverableReactionPickerSelectorList ? "ul" : undefined;
        const t9 = shouldRenderHoverableReactionPickerSelectorList ? $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorList : $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer;
        let t10;
        if ($[14] !== quickReactionEmojiIds || $[15] !== renderEmoji) {
            t10 = quickReactionEmojiIds.map(renderEmoji);
            $[14] = quickReactionEmojiIds;
            $[15] = renderEmoji;
            $[16] = t10;
        } else t10 = $[16];
        let t11;
        if ($[17] !== t10 || $[18] !== t8 || $[19] !== t9) {
            t11 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: t8,
                alignBlock: "center",
                xcss: t9
            }, t10);
            $[17] = t10;
            $[18] = t8;
            $[19] = t9;
            $[20] = t11;
        } else t11 = $[20];
        let t12;
        if ($[21] !== t11 || $[22] !== t7) {
            t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer
            }, t7, t11);
            $[21] = t11;
            $[22] = t7;
            $[23] = t12;
        } else t12 = $[23];
        return t12;
    }
    let t7;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $ieeJu.expValEquals)("platform_a11y_fixes_reactions_selector_list", "isEnabled", true);
        $[24] = t7;
    } else t7 = $[24];
    const isSelectorListMarkupFixEnabled = t7;
    let t8;
    if ($[25] !== quickReactionEmojiIds || $[26] !== renderEmoji) {
        t8 = quickReactionEmojiIds.map(renderEmoji);
        $[25] = quickReactionEmojiIds;
        $[26] = renderEmoji;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== onMoreClick || $[29] !== showMore) {
        t9 = showMore ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: isSelectorListMarkupFixEnabled ? undefined : "li",
            xcss: $a2ab395c45579380$var$styles.separator,
            "aria-hidden": isSelectorListMarkupFixEnabled ? true : undefined
        }), /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, null, /*#__PURE__*/ $cozmU.createElement((0, $a5eeba0f96f1fb4c$export$ca7697601dcd7803), {
            key: "more",
            onClick: onMoreClick
        }))) : null;
        $[28] = onMoreClick;
        $[29] = showMore;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== t8 || $[32] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            xcss: $a2ab395c45579380$var$styles.container,
            as: isSelectorListMarkupFixEnabled ? undefined : "ul",
            role: isSelectorListMarkupFixEnabled ? "group" : undefined,
            "aria-label": isSelectorListMarkupFixEnabled ? (0, $jFWFL.messages).popperWrapperLabel.defaultMessage : undefined
        }, t8, t9);
        $[31] = t8;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ emojiProvider: emojiProvider, onMoreClick: onMoreClick, onSelection: onSelection, showMore: showMore, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, hoverableReactionPickerSelector: hoverableReactionPickerSelector = false })=>{
    const [isTeamojiPickerRefreshEnabled, setIsTeamojiPickerRefreshEnabled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsTeamojiPickerRefreshEnabled((0, $ieeJu.expValEquals)('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', true));
    }, []);
    const quickReactionEmojiIds = pickerQuickReactionEmojiIds ?? (0, $lbdYm.getDefaultReactions)(isTeamojiPickerRefreshEnabled);
    const shouldRenderHoverableReactionPickerSelectorList = hoverableReactionPickerSelector && (0, $4o0zT.isExperimentEnabled)('platform_a11y_reactions_hover_selector_list'); /**
                                                                                                                                                                  * Render the default emoji icon
                                                                                                                                                                  * @param emoji emoji item
                                                                                                                                                                  * @param index location of the emoji in the array
                                                                                                                                                                  */ 
    const renderEmoji = (emoji, index)=>{
        const emojiButtonAndTooltip = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            key: emoji.id ?? emoji.shortName,
            content: emoji.shortName
        }, /*#__PURE__*/ $cozmU.createElement((0, $a824af7beab19c72$export$e6ce3311a4d41b7f), {
            emojiId: emoji,
            emojiProvider: emojiProvider,
            onClick: onSelection,
            hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelector
        }));
        return hoverableReactionPickerSelector ? shouldRenderHoverableReactionPickerSelectorList ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            key: emoji.id ?? emoji.shortName,
            xcss: $a2ab395c45579380$var$styles.emojiContainer
        }, emojiButtonAndTooltip) : emojiButtonAndTooltip : /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, {
            key: emoji.id ?? emoji.shortName,
            testId: $a2ab395c45579380$export$fbfb01485b140555
        }, emojiButtonAndTooltip);
    };
    if (hoverableReactionPickerSelector) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $5a2af3b1f8e184d8$export$41fb9f06171c75f4), {
        tooltipContent: (0, $jFWFL.messages).addReaction.defaultMessage,
        onClick: onMoreClick,
        showAddReactionText: true,
        reactionPickerTriggerText: (0, $jFWFL.messages).addNewReaction.defaultMessage,
        fullWidthSelectorTrayReactionPickerTrigger: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        as: shouldRenderHoverableReactionPickerSelectorList ? 'ul' : undefined,
        alignBlock: "center",
        xcss: shouldRenderHoverableReactionPickerSelectorList ? $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorList : $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer
    }, quickReactionEmojiIds.map(renderEmoji)));
    const isSelectorListMarkupFixEnabled = (0, $ieeJu.expValEquals)('platform_a11y_fixes_reactions_selector_list', 'isEnabled', true);
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $a2ab395c45579380$var$styles.container,
        as: isSelectorListMarkupFixEnabled ? undefined : 'ul',
        role: isSelectorListMarkupFixEnabled ? 'group' : undefined,
        "aria-label": isSelectorListMarkupFixEnabled ? (0, $jFWFL.messages).popperWrapperLabel.defaultMessage : undefined
    }, quickReactionEmojiIds.map(renderEmoji), showMore ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: isSelectorListMarkupFixEnabled ? undefined : 'li',
        xcss: $a2ab395c45579380$var$styles.separator,
        "aria-hidden": isSelectorListMarkupFixEnabled ? true : undefined
    }), /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, null, /*#__PURE__*/ $cozmU.createElement((0, $a5eeba0f96f1fb4c$export$ca7697601dcd7803), {
        key: "more",
        onClick: onMoreClick
    }))) : null);
};












const $212e91376d92dc65$export$51eddd7655ca235a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, update: update, settings: settings } = t0;
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    let t1;
    if ($[0] !== update) {
        t1 = ()=>{
            if (isFirstRenderRef.current) {
                isFirstRenderRef.current = false;
                return;
            }
            update();
        };
        $[0] = update;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== settings || $[3] !== update) {
        t2 = [
            update,
            settings
        ];
        $[2] = settings;
        $[3] = update;
        $[4] = t2;
    } else t2 = $[4];
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[5] = children;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, update: update, settings: settings })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        settings
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};



var $cK21K = parcelRequire("cK21K");




const $947dedcc17ccb720$var$pickerStyle = null;
const $947dedcc17ccb720$var$popupWrapperStyle = null;
const $947dedcc17ccb720$var$popupStyle = null;
const $947dedcc17ccb720$var$visuallyHiddenStyle = null;
const $947dedcc17ccb720$var$additionalStyles = {
    selectorContainer: "_3iDTPbQ4SZ"
}; /**
    * Test id for wrapper ReactionPicker div
    */ 
const $947dedcc17ccb720$export$4e9694165fb83edd = 'reactionPicker-testid'; /**
                                                                      * Test id for ReactionPicker panel div
                                                                      */ 
const $947dedcc17ccb720$export$d52b610bc836b6d7 = 'reactionPickerPanel-testid'; /**
                                                                                * Emoji Picker Controller Id for Accessibility Labels
                                                                                */ 
const $947dedcc17ccb720$var$PICKER_CONTROL_ID = 'emoji-picker';
const $947dedcc17ccb720$var$PICKER_LABEL_ID = 'emoji-picker-label';
const $947dedcc17ccb720$export$1d5ec51e9af399a5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { miniMode: miniMode, className: className, emojiProvider: emojiProvider, onSelection: onSelection, allowAllEmojis: allowAllEmojis, disabled: disabled, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, onShowMore: onShowMore = ()=>{}, onOpen: onOpen = ()=>{}, onCancel: onCancel = ()=>{}, tooltipContent: tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).addReaction), emojiPickerSize: emojiPickerSize, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText, reactionPickerPlacement: reactionPickerPlacement, isListItem: isListItem = false, hoverableReactionPicker: hoverableReactionPicker = false, hoverableReactionPickerDelay: hoverableReactionPickerDelay = 0, reactionPickerPopperZIndex: reactionPickerPopperZIndex } = props;
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    const [isHoverableReactionPickerEmojiPickerOpen, setIsHoverableReactionPickerEmojiPickerOpen] = (0, $cozmU.useState)(false);
    const [isHoveringTrigger, setIsHoveringTrigger] = (0, $cozmU.useState)(false);
    const [isHoveringPopup, setIsHoveringPopup] = (0, $cozmU.useState)(false);
    const [isTriggerClicked, setIsTriggerClicked] = (0, $cozmU.useState)(false);
    const [isPopupTrayOpen, setIsPopupTrayOpen] = (0, $ca45144c595c321e$export$94d25041dfc7e5be)(false, hoverableReactionPickerDelay); /**
                                                                                                                * Container <div /> reference (used by custom hook to detect click outside)
                                                                                                                */ 
    const wrapperRef = (0, $cozmU.useRef)(null);
    const updatePopper = (0, $cozmU.useRef)();
    const popperPlacement = reactionPickerPlacement || 'bottom-start';
    const popperModifiers = [
        /**
    Removing this applyStyle modifier as it throws client errors ref:
   https://popper.js.org/docs/v1/#modifiers
   https://popper.js.org/docs/v1/#modifiers..applyStyle
   { name: 'applyStyle', enabled: false },
    */ {
            name: 'hide',
            enabled: false
        },
        {
            name: 'offset',
            enabled: true,
            options: {
                offset: [
                    0,
                    4
                ]
            }
        },
        {
            name: 'flip',
            enabled: true,
            options: {
                flipVariations: true,
                boundariesElement: 'scrollParent'
            }
        }
    ];
    const [settings, setSettings] = (0, $cozmU.useState)({
        /**
     * Show the full custom emoji list picker or the default list of emojis
     */ showFullPicker: !!allowAllEmojis && Array.isArray(pickerQuickReactionEmojiIds) && pickerQuickReactionEmojiIds.length === 0,
        popperPlacement: /**
     * Use placement for popper based on reactionPickerPlacement prop
     */ popperPlacement
    }); /**
       * Event callback when the picker is closed
       * @param _id Optional id if an emoji button was selected or undefineed if was clicked outside the picker
       */ 
    const close = (0, $cozmU.useCallback)((_id)=>{
        setIsPopupTrayOpen(false, true); // ufo abort reaction experience
        (0, $97zIA.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(false);
            setIsTriggerClicked(false);
            setIsHoveringTrigger(false);
            setIsHoveringPopup(false);
        }
    }, [
        setIsPopupTrayOpen,
        setIsHoverableReactionPickerEmojiPickerOpen,
        hoverableReactionPicker,
        setIsTriggerClicked,
        setIsHoveringTrigger,
        setIsHoveringPopup
    ]); /**
                                                                                                                                                                  * Event handle rwhen selecting to show the custom emoji icons picker
                                                                                                                                                                  * @param e event param
                                                                                                                                                                  */ 
    const onSelectMoreClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setSettings({
            showFullPicker: hoverableReactionPicker ? settings.showFullPicker : true,
            popperPlacement: popperPlacement
        });
        setIsPopupTrayOpen(true);
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(!isHoverableReactionPickerEmojiPickerOpen);
            setIsTriggerClicked(false);
        }
        onShowMore();
    }, [
        settings.showFullPicker,
        setIsPopupTrayOpen,
        onShowMore,
        popperPlacement,
        hoverableReactionPicker,
        setIsHoverableReactionPickerEmojiPickerOpen,
        isHoverableReactionPickerEmojiPickerOpen
    ]); /**
                                                                                                                                                                                                   * Event callback when an emoji icon is selected
                                                                                                                                                                                                   * @param item selected item
                                                                                                                                                                                                   */ 
    const onEmojiSelected = (0, $cozmU.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? 'emojiPicker' : 'quickSelector');
        close(item.id); // After selecting an emoji, we would like focus to be returned to the trigger button
        // This is for the purposes of navigation for keyboard users
        requestAnimationFrame(()=>triggerRef?.focus());
    }, [
        close,
        onSelection,
        settings.showFullPicker,
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        triggerRef
    ]); /**
                                                                                                                                     * Event handler when the emoji icon to open the custom picker is selected
                                                                                                                                     */ 
    const onTriggerClick = (0, $cozmU.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $97zIA.PickerRender).start();
        setSettings({
            ...settings,
            popperPlacement: popperPlacement
        });
        if (hoverableReactionPicker) {
            if (isHoverableReactionPickerEmojiPickerOpen || isTriggerClicked) {
                // if either the emoji picker is open or the trigger was clicked, close the popup and reset the state
                setIsTriggerClicked(false);
                setIsPopupTrayOpen(false, true);
            } else {
                // if neither condition is true, open the popup and set the state
                setIsTriggerClicked(true);
                setIsPopupTrayOpen(true, true);
            } // close the emoji picker
            setIsHoverableReactionPickerEmojiPickerOpen(false);
        } else setIsPopupTrayOpen(!isPopupTrayOpen);
        onOpen(); // ufo reactions picker opened success
        (0, $97zIA.PickerRender).success({
            metadata: {
                readingOrderInline: (0, $iDrrr.fg)('a11y_reactions_reading_order')
            }
        });
    }, [
        hoverableReactionPicker,
        isPopupTrayOpen,
        setIsPopupTrayOpen,
        isTriggerClicked,
        setIsTriggerClicked,
        isHoverableReactionPickerEmojiPickerOpen,
        onOpen,
        settings,
        popperPlacement
    ]);
    const handleTriggerMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handleTriggerMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(false);
            if (!isHoveringPopup && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringPopup,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const handlePopupMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handlePopupMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(false);
            if (!isHoveringTrigger && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringTrigger,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const wrapperClassName = ` ${isPopupTrayOpen ? 'isOpen' : ''} ${miniMode ? 'miniMode' : ''} ${className}`;
    (0, $cozmU.useLayoutEffect)(()=>{
        updatePopper.current?.();
    }, [
        settings
    ]);
    const onClose = ()=>{
        close();
        onCancel();
    };
    const pickerPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($947dedcc17ccb720$export$8c62d061746e97b3, {
        settings: settings,
        popperModifiers: popperModifiers,
        isOpen: isPopupTrayOpen,
        onClose: onClose,
        triggerRef: triggerRef,
        zIndex: reactionPickerPopperZIndex || (0, $jp2Q3.layers).flag()
    }, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $947dedcc17ccb720$var$additionalStyles.selectorContainer,
        onMouseEnter: handlePopupMouseEnter,
        onMouseLeave: handlePopupMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2XZ.default), {
        emojiProvider: emojiProvider,
        onSelection: onEmojiSelected,
        size: emojiPickerSize
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $947dedcc17ccb720$var$additionalStyles.selectorContainer,
        onMouseEnter: handlePopupMouseEnter,
        onMouseLeave: handlePopupMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2ab395c45579380$export$d15f4cd5286f9b1e), {
        emojiProvider: emojiProvider,
        onSelection: onEmojiSelected,
        showMore: allowAllEmojis,
        onMoreClick: onSelectMoreClick,
        pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
        hoverableReactionPickerSelector: hoverableReactionPicker
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_1RrJLit2nV _44IyhFvbI6",
            wrapperClassName
        ]),
        "data-testid": $947dedcc17ccb720$export$4e9694165fb83edd,
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akErP.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kN1yU.Reference), null, ({ ref: ref })=>// Render a button to open the <Selector /> panel
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseEnter: handleTriggerMouseEnter,
            onMouseLeave: handleTriggerMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a2af3b1f8e184d8$export$41fb9f06171c75f4), {
            ariaAttributes: {
                'aria-expanded': isPopupTrayOpen,
                'aria-controls': $947dedcc17ccb720$var$PICKER_CONTROL_ID,
                ...isPopupTrayOpen && (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? {
                    'aria-owns': $947dedcc17ccb720$var$PICKER_CONTROL_ID
                } : {}
            },
            ref: (node)=>{
                if (node && isPopupTrayOpen) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setTriggerRef(node);
                }
            },
            isSelected: isPopupTrayOpen,
            onClick: onTriggerClick,
            miniMode: miniMode,
            disabled: disabled,
            tooltipContent: isPopupTrayOpen ? null : tooltipContent,
            showOpaqueBackground: showOpaqueBackground,
            showAddReactionText: showAddReactionText,
            subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
            reactionPickerTriggerIcon: reactionPickerTriggerIcon,
            reactionPickerTriggerText: reactionPickerTriggerText,
            isListItem: isListItem,
            emojiPickerSize: emojiPickerSize
        }))), isPopupTrayOpen && ((0, $iDrrr.fg)('a11y_reactions_reading_order') ? // Render the picker panel inline (a DOM sibling directly after the trigger)
    // so assistive technologies encounter the expanded content in the correct
    // reading order. The popper still positions with `position: fixed`, so the
    // visual placement is unchanged.
    pickerPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: reactionPickerPopperZIndex || (0, $jp2Q3.layers).flag()
    }, pickerPanel))));
});
const $947dedcc17ccb720$export$8c62d061746e97b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(15);
    const { triggerRef: triggerRef, settings: settings, isOpen: isOpen, onClose: onClose, children: children, popperModifiers: popperModifiers, zIndex: zIndex } = props;
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== popupRef) {
        t0 = {
            initialFocusRef: null,
            targetRef: popupRef
        };
        $[0] = popupRef;
        $[1] = t0;
    } else t0 = $[1];
    (0, $6cb1a3d2db6a68e4$export$5562a1f223a0d314)(t0);
    let t1;
    if ($[2] !== onClose || $[3] !== popupRef || $[4] !== triggerRef) {
        t1 = (callbackType)=>{
            onClose();
            if (popupRef && callbackType === "ESCAPE") requestAnimationFrame(()=>triggerRef?.focus());
        };
        $[2] = onClose;
        $[3] = popupRef;
        $[4] = triggerRef;
        $[5] = t1;
    } else t1 = $[5];
    (0, $cd2f8ae127029e1f$export$d6c3c92a8b7167c2)(popupRef, triggerRef, t1, true, isOpen);
    let t2;
    if ($[6] !== children || $[7] !== formatMessage || $[8] !== settings || $[9] !== zIndex) {
        t2 = (t3)=>{
            const { ref: ref, style: style, update: update } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                role: "dialog",
                "aria-label": (0, $iDrrr.fg)("platform_a11y_fixes_reading_order") ? undefined : formatMessage((0, $jFWFL.messages).popperWrapperLabel),
                "aria-modal": (0, $iDrrr.fg)("platform_a11y_fixes_reading_order") ? "false" : undefined,
                "aria-labelledby": (0, $iDrrr.fg)("platform_a11y_fixes_reading_order") ? $947dedcc17ccb720$var$PICKER_LABEL_ID : undefined,
                id: $947dedcc17ccb720$var$PICKER_CONTROL_ID,
                "data-testid": $947dedcc17ccb720$export$d52b610bc836b6d7,
                style: {
                    zIndex: zIndex,
                    ...style
                },
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === "function") ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                tabIndex: (0, $iDrrr.fg)("platform_suppression_removal_fix_reactions") ? undefined : 0,
                className: (0, $hekY6.default)([
                    "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp"
                ])
            }, (0, $iDrrr.fg)("platform_a11y_fixes_reading_order") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_4bt5LAnQyn _2WAcuGnQyn _1C7BHPdEFh _0jFU0VHZdu _1mT5xdWVPG _1ANEUSLRg7 _39xV02HZdu"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                as: "h2",
                size: "small",
                id: $947dedcc17ccb720$var$PICKER_LABEL_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).popperWrapperLabel))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $212e91376d92dc65$export$51eddd7655ca235a), {
                update: update,
                settings: settings
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_0bjKvDzXzM _0KLXruoI2d _2OUyjtGk8v _0tKlqQ1Y8M"
                ])
            }, children)));
        };
        $[6] = children;
        $[7] = formatMessage;
        $[8] = settings;
        $[9] = zIndex;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== popperModifiers || $[12] !== settings.popperPlacement || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
            placement: settings.popperPlacement,
            modifiers: popperModifiers
        }, t2);
        $[11] = popperModifiers;
        $[12] = settings.popperPlacement;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : (props)=>{
    const { triggerRef: triggerRef, settings: settings, isOpen: isOpen, onClose: onClose, children: children, popperModifiers: popperModifiers, zIndex: zIndex } = props;
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); /**
                  * add focus lock to popup
                  */ 
    (0, $6cb1a3d2db6a68e4$export$5562a1f223a0d314)({
        initialFocusRef: null,
        targetRef: popupRef
    }); /**
       * Custom hook triggers when user clicks outside the reactions picker
       */ 
    (0, $cd2f8ae127029e1f$export$d6c3c92a8b7167c2)(popupRef, triggerRef, (callbackType)=>{
        onClose();
        if (popupRef && callbackType === 'ESCAPE') requestAnimationFrame(()=>triggerRef?.focus());
    }, true, isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
        placement: settings.popperPlacement,
        modifiers: popperModifiers
    }, ({ ref: ref, style: style, update: update })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-label": (0, $iDrrr.fg)('platform_a11y_fixes_reading_order') ? undefined : formatMessage((0, $jFWFL.messages).popperWrapperLabel),
            "aria-modal": (0, $iDrrr.fg)('platform_a11y_fixes_reading_order') ? 'false' : undefined,
            "aria-labelledby": (0, $iDrrr.fg)('platform_a11y_fixes_reading_order') ? $947dedcc17ccb720$var$PICKER_LABEL_ID : undefined,
            id: $947dedcc17ccb720$var$PICKER_CONTROL_ID,
            "data-testid": $947dedcc17ccb720$export$d52b610bc836b6d7,
            style: {
                zIndex: zIndex,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...style
            },
            ref: (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setPopupRef(node);
                }
            },
            tabIndex: (0, $iDrrr.fg)('platform_suppression_removal_fix_reactions') ? undefined : 0,
            className: (0, $hekY6.default)([
                "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp"
            ])
        }, (0, $iDrrr.fg)('platform_a11y_fixes_reading_order') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1C7BHPdEFh _0jFU0VHZdu _1mT5xdWVPG _1ANEUSLRg7 _39xV02HZdu"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "small",
            id: $947dedcc17ccb720$var$PICKER_LABEL_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).popperWrapperLabel))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $212e91376d92dc65$export$51eddd7655ca235a), {
            update: update,
            settings: settings
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _0KLXruoI2d _2OUyjtGk8v _0tKlqQ1Y8M"
            ])
        }, children)));
    });
};












var $4n1IT = parcelRequire("4n1IT");








































var $3dtSX = parcelRequire("3dtSX");


var $e1UZX = parcelRequire("e1UZX");













const $c2486cdaea993b56$var$styles = {
    emoji: "_0yKXXaDGiX",
    button: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q2ADO",
    container: "_1mT5xdRAKS",
    summaryButtonIconAfter: "_1Znuxb2ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    emojiPlaceholderBackground: "_0KLXruGsB2",
    particleEffectContainer: "_1ZnuxbNHnM"
};
const $c2486cdaea993b56$export$bf8263842b2b0eb6 = 'reaction-summary-button'; /**
                                                                        * Test id for emojis displayed inside summary button. All emoji's in the summary button will have this test id
                                                                        */ 
const $c2486cdaea993b56$export$6adb00c908f27fce = 'summary-emoji-display'; // forwardRef is used here so that the parent popup component can properly interact with the button
const $c2486cdaea993b56$export$cc50c972184463a7 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(45);
    const { emojiProvider: emojiProvider, reactions: t1, emojisToShow: t2, onClick: onClick, showOpaqueBackground: t3, subtleReactionsSummaryAndPicker: t4, useButtonAlignmentStyling: t5, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId, isOpen: isOpen } = t0;
    let t6;
    if ($[0] !== t1) {
        t6 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t6;
    } else t6 = $[1];
    const reactions = t6;
    const emojisToShow = t2 === undefined ? 3 : t2;
    const showOpaqueBackground = t3 === undefined ? false : t3;
    const subtleReactionsSummaryAndPicker = t4 === undefined ? false : t4;
    const useButtonAlignmentStyling = t5 === undefined ? false : t5;
    const intl = (0, $kSwu1.useIntl)();
    const getTopReactions = $c2486cdaea993b56$var$_temp2;
    let t7;
    if ($[2] !== reactions) {
        t7 = reactions.reduce($c2486cdaea993b56$var$_temp3, 0);
        $[2] = reactions;
        $[3] = t7;
    } else t7 = $[3];
    const totalReactionsCount = t7;
    let t8;
    if ($[4] !== emojisToShow || $[5] !== reactions) {
        t8 = getTopReactions(reactions, emojisToShow);
        $[4] = emojisToShow;
        $[5] = reactions;
        $[6] = t8;
    } else t8 = $[6];
    const topReactions = t8;
    let t9;
    if ($[7] !== emojiProvider || $[8] !== summaryViewParticleEffectEmojiId) {
        t9 = summaryViewParticleEffectEmojiId && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c2486cdaea993b56$var$styles.particleEffectContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
            key: summaryViewParticleEffectEmojiId.id,
            emojiId: summaryViewParticleEffectEmojiId,
            emojiProvider: emojiProvider
        }));
        $[7] = emojiProvider;
        $[8] = summaryViewParticleEffectEmojiId;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== intl || $[11] !== totalReactionsCount) {
        t10 = intl.formatMessage((0, $jFWFL.messages).summary, {
            count: totalReactionsCount
        });
        $[10] = intl;
        $[11] = totalReactionsCount;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $k12R1.cx)($c2486cdaea993b56$var$styles.button);
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== emojiProvider || $[15] !== summaryGetOptimisticImageURL || $[16] !== topReactions) {
        let t13;
        if ($[18] !== emojiProvider || $[19] !== summaryGetOptimisticImageURL) {
            t13 = (reaction)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $c2486cdaea993b56$var$styles.emoji,
                    testId: $c2486cdaea993b56$export$6adb00c908f27fce,
                    style: {
                        lineHeight: "12px"
                    }
                }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
                    key: reaction.emojiId,
                    emojiProvider: emojiProvider,
                    emojiId: {
                        id: reaction.emojiId,
                        shortName: ""
                    },
                    fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
                    optimisticImageURL: summaryGetOptimisticImageURL?.(reaction.emojiId),
                    placeholderXcss: $c2486cdaea993b56$var$styles.emojiPlaceholderBackground
                }));
            $[18] = emojiProvider;
            $[19] = summaryGetOptimisticImageURL;
            $[20] = t13;
        } else t13 = $[20];
        t12 = topReactions.map(t13);
        $[14] = emojiProvider;
        $[15] = summaryGetOptimisticImageURL;
        $[16] = topReactions;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[21] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            xcss: t11,
            testId: "reaction-summary-wrapper"
        }, t12);
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== totalReactionsCount || $[24] !== useButtonAlignmentStyling) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
            value: totalReactionsCount,
            useDarkerFont: useButtonAlignmentStyling,
            useUpdatedStyles: useButtonAlignmentStyling
        });
        $[23] = totalReactionsCount;
        $[24] = useButtonAlignmentStyling;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== summaryButtonIconAfter) {
        t15 = summaryButtonIconAfter && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c2486cdaea993b56$var$styles.summaryButtonIconAfter
        }, summaryButtonIconAfter);
        $[26] = summaryButtonIconAfter;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== isOpen || $[29] !== onClick || $[30] !== onMouseEnter || $[31] !== onMouseLeave || $[32] !== showOpaqueBackground || $[33] !== subtleReactionsSummaryAndPicker || $[34] !== t10 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            testId: $c2486cdaea993b56$export$bf8263842b2b0eb6,
            ariaLabel: t10,
            ariaExpanded: isOpen,
            showSubtleStyle: subtleReactionsSummaryAndPicker,
            showOpaqueBackground: showOpaqueBackground
        }, t13, t14, t15);
        $[28] = isOpen;
        $[29] = onClick;
        $[30] = onMouseEnter;
        $[31] = onMouseLeave;
        $[32] = showOpaqueBackground;
        $[33] = subtleReactionsSummaryAndPicker;
        $[34] = t10;
        $[35] = t13;
        $[36] = t14;
        $[37] = t15;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== t16 || $[40] !== t9) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            alignInline: "center"
        }, t9, t16);
        $[39] = t16;
        $[40] = t9;
        $[41] = t17;
    } else t17 = $[41];
    let t18;
    if ($[42] !== ref || $[43] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $c2486cdaea993b56$var$styles.container,
            ref: ref,
            alignItems: "center",
            justifyContent: "center"
        }, t17);
        $[42] = ref;
        $[43] = t17;
        $[44] = t18;
    } else t18 = $[44];
    return t18;
} : ({ emojiProvider: emojiProvider, reactions: reactions = [], emojisToShow: emojisToShow = 3, onClick: onClick, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId, isOpen: isOpen }, ref)=>{
    const intl = (0, $kSwu1.useIntl)(); // Helper function to sort reactions by count and return top N
    const getTopReactions = (reactions_0, topN)=>{
        return [
            ...reactions_0
        ].sort((a, b)=>b.count - a.count).slice(0, topN);
    };
    const totalReactionsCount = (0, $cozmU.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count || 0;
        }, 0);
    }, [
        reactions
    ]);
    const topReactions = (0, $cozmU.useMemo)(()=>getTopReactions(reactions, emojisToShow), [
        emojisToShow,
        reactions
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $c2486cdaea993b56$var$styles.container,
        ref: ref,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        alignInline: "center"
    }, summaryViewParticleEffectEmojiId && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c2486cdaea993b56$var$styles.particleEffectContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
        key: summaryViewParticleEffectEmojiId.id,
        emojiId: summaryViewParticleEffectEmojiId,
        emojiProvider: emojiProvider
    })), /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: $c2486cdaea993b56$export$bf8263842b2b0eb6,
        ariaLabel: intl.formatMessage((0, $jFWFL.messages).summary, {
            count: totalReactionsCount
        }),
        ariaExpanded: isOpen,
        showSubtleStyle: subtleReactionsSummaryAndPicker,
        showOpaqueBackground: showOpaqueBackground
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        xcss: (0, $k12R1.cx)($c2486cdaea993b56$var$styles.button),
        testId: "reaction-summary-wrapper"
    }, topReactions.map((reaction)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c2486cdaea993b56$var$styles.emoji,
            testId: $c2486cdaea993b56$export$6adb00c908f27fce,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                lineHeight: '12px'
            }
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            key: reaction.emojiId,
            emojiProvider: emojiProvider,
            emojiId: {
                id: reaction.emojiId,
                shortName: ''
            },
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            optimisticImageURL: summaryGetOptimisticImageURL?.(reaction.emojiId),
            placeholderXcss: $c2486cdaea993b56$var$styles.emojiPlaceholderBackground
        })))), /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
        value: totalReactionsCount,
        useDarkerFont: useButtonAlignmentStyling,
        useUpdatedStyles: useButtonAlignmentStyling
    }), summaryButtonIconAfter && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c2486cdaea993b56$var$styles.summaryButtonIconAfter
    }, summaryButtonIconAfter))));
});
function $c2486cdaea993b56$var$_temp(a, b) {
    return b.count - a.count;
}
function $c2486cdaea993b56$var$_temp2(reactions_0, topN) {
    return [
        ...reactions_0
    ].sort($c2486cdaea993b56$var$_temp).slice(0, topN);
}
function $c2486cdaea993b56$var$_temp3(accum, current) {
    accum = accum + (current?.count || 0);
    return accum;
}












const $741d424eddcf1ce0$var$styles = {
    summaryPopup: "_0Of8r21Y8M _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _1EqgXll0GD",
    summaryList: "_0Of8r21Y8M _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _1EqgXll0GD _0aNu0LYbGa"
}; /**
    * Test id for the Reactions summary view popup
    */ 
const $741d424eddcf1ce0$export$55d575bd4bcbc45e = 'render-summary-view-popup';
const $741d424eddcf1ce0$export$d441f1c2eaaec099 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(85);
    const { emojiProvider: emojiProvider, reactions: t1, flash: t2, particleEffectByEmoji: t3, placement: t4, onReactionClick: onReactionClick, onReactionFocused: onReactionFocused, onReactionMouseEnter: onReactionMouseEnter, showOpaqueBackground: t5, subtleReactionsSummaryAndPicker: t6, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: t7, allowSelectFromSummaryView: allowSelectFromSummaryView, disabled: disabled, emojiPickerSize: emojiPickerSize, onSelection: onSelection, tooltipContent: tooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, onOpen: onOpen, useButtonAlignmentStyling: useButtonAlignmentStyling, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: t8, hoverableSummaryViewDelay: t9, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId } = t0;
    let t10;
    if ($[0] !== t1) {
        t10 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t10;
    } else t10 = $[1];
    const reactions = t10;
    let t11;
    if ($[2] !== t2) {
        t11 = t2 === undefined ? {} : t2;
        $[2] = t2;
        $[3] = t11;
    } else t11 = $[3];
    const flash = t11;
    let t12;
    if ($[4] !== t3) {
        t12 = t3 === undefined ? {} : t3;
        $[4] = t3;
        $[5] = t12;
    } else t12 = $[5];
    const particleEffectByEmoji = t12;
    const placement = t4 === undefined ? "auto-start" : t4;
    const showOpaqueBackground = t5 === undefined ? false : t5;
    const subtleReactionsSummaryAndPicker = t6 === undefined ? false : t6;
    const isViewOnly = t7 === undefined ? false : t7;
    const hoverableSummaryView = t8 === undefined ? false : t8;
    const hoverableSummaryViewDelay = t9 === undefined ? 300 : t9;
    const [isSummaryPopupOpen, setSummaryPopupOpen] = (0, $ca45144c595c321e$export$94d25041dfc7e5be)(false, hoverableSummaryViewDelay);
    const [isHoveringSummaryView, setIsHoveringSummaryView] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonHovered, setIsSummaryViewButtonHovered] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonClicked, setIsSummaryViewButtonClicked] = (0, $cozmU.useState)(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $cozmU.useState)(false);
    let t13;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (_id)=>{
            setIsEmojiPickerOpen(false);
            (0, $97zIA.PickerRender).abort({
                metadata: {
                    emojiId: _id,
                    source: "ReactionPicker",
                    reason: "close dialog"
                }
            });
        };
        $[6] = t13;
    } else t13 = $[6];
    const close = t13;
    let t14;
    if ($[7] !== onSelection) {
        t14 = (item)=>{
            if (!item.id) return;
            onSelection(item.id, "emojiPicker");
            close(item.id);
        };
        $[7] = onSelection;
        $[8] = t14;
    } else t14 = $[8];
    const onEmojiSelected = t14;
    let t15;
    if ($[9] !== setSummaryPopupOpen) {
        t15 = ()=>{
            setSummaryPopupOpen(false, true);
            setIsEmojiPickerOpen(false);
            setIsSummaryViewButtonClicked(false);
            setIsSummaryViewButtonHovered(false);
            setIsHoveringSummaryView(false);
        };
        $[9] = setSummaryPopupOpen;
        $[10] = t15;
    } else t15 = $[10];
    const handlePopupClose = t15;
    let t16;
    if ($[11] !== onOpen) {
        t16 = ()=>{
            (0, $97zIA.PickerRender).start();
            onOpen && onOpen();
            setIsEmojiPickerOpen(true);
            (0, $97zIA.PickerRender).success();
        };
        $[11] = onOpen;
        $[12] = t16;
    } else t16 = $[12];
    const openEmojiPicker = t16;
    let t17;
    if ($[13] !== openEmojiPicker || $[14] !== setSummaryPopupOpen) {
        t17 = ()=>{
            openEmojiPicker();
            setSummaryPopupOpen(false, true);
            setIsSummaryViewButtonClicked(false);
            setIsSummaryViewButtonHovered(false);
            setIsHoveringSummaryView(false);
        };
        $[13] = openEmojiPicker;
        $[14] = setSummaryPopupOpen;
        $[15] = t17;
    } else t17 = $[15];
    const handleEmojiPickerTriggerClick = t17;
    let t18;
    if ($[16] !== handlePopupClose || $[17] !== hoverableSummaryView || $[18] !== isEmojiPickerOpen || $[19] !== isSummaryPopupOpen || $[20] !== isSummaryViewButtonClicked || $[21] !== setSummaryPopupOpen) {
        t18 = ()=>{
            if (hoverableSummaryView) {
                setIsHoveringSummaryView(false);
                setIsSummaryViewButtonHovered(false);
                if (isEmojiPickerOpen || isSummaryViewButtonClicked) {
                    setSummaryPopupOpen(false, true);
                    setIsSummaryViewButtonClicked(false);
                } else {
                    setSummaryPopupOpen(true, true);
                    setIsSummaryViewButtonClicked(true);
                }
                setIsEmojiPickerOpen(false);
            } else if (isSummaryPopupOpen) handlePopupClose();
            else setSummaryPopupOpen(true);
        };
        $[16] = handlePopupClose;
        $[17] = hoverableSummaryView;
        $[18] = isEmojiPickerOpen;
        $[19] = isSummaryPopupOpen;
        $[20] = isSummaryViewButtonClicked;
        $[21] = setSummaryPopupOpen;
        $[22] = t18;
    } else t18 = $[22];
    const handleSummaryClick = t18;
    let t19;
    if ($[23] !== hoverableSummaryView || $[24] !== isEmojiPickerOpen || $[25] !== setSummaryPopupOpen) {
        t19 = ()=>{
            setIsSummaryViewButtonHovered(true);
            if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
        };
        $[23] = hoverableSummaryView;
        $[24] = isEmojiPickerOpen;
        $[25] = setSummaryPopupOpen;
        $[26] = t19;
    } else t19 = $[26];
    const handleButtonMouseEnter = t19;
    let t20;
    if ($[27] !== hoverableSummaryView || $[28] !== isHoveringSummaryView || $[29] !== isSummaryViewButtonClicked || $[30] !== setSummaryPopupOpen) {
        t20 = ()=>{
            setIsSummaryViewButtonHovered(false);
            if (hoverableSummaryView && !isHoveringSummaryView && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
        };
        $[27] = hoverableSummaryView;
        $[28] = isHoveringSummaryView;
        $[29] = isSummaryViewButtonClicked;
        $[30] = setSummaryPopupOpen;
        $[31] = t20;
    } else t20 = $[31];
    const handleButtonMouseLeave = t20;
    let t21;
    if ($[32] !== hoverableSummaryView || $[33] !== isEmojiPickerOpen || $[34] !== setSummaryPopupOpen) {
        t21 = ()=>{
            setIsHoveringSummaryView(true);
            if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
        };
        $[32] = hoverableSummaryView;
        $[33] = isEmojiPickerOpen;
        $[34] = setSummaryPopupOpen;
        $[35] = t21;
    } else t21 = $[35];
    const handleSummaryViewTrayMouseEnter = t21;
    let t22;
    if ($[36] !== hoverableSummaryView || $[37] !== isSummaryViewButtonClicked || $[38] !== isSummaryViewButtonHovered || $[39] !== setSummaryPopupOpen) {
        t22 = ()=>{
            setIsHoveringSummaryView(false);
            if (hoverableSummaryView && !isSummaryViewButtonHovered && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
        };
        $[36] = hoverableSummaryView;
        $[37] = isSummaryViewButtonClicked;
        $[38] = isSummaryViewButtonHovered;
        $[39] = setSummaryPopupOpen;
        $[40] = t22;
    } else t22 = $[40];
    const handleSummaryViewTrayMouseLeave = t22;
    let t23;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $4o0zT.isExperimentEnabled)("platform_a11y_reactions_hover_selector_list");
        $[41] = t23;
    } else t23 = $[41];
    const shouldRenderReactionSummaryList = t23;
    let t24;
    if ($[42] !== allowSelectFromSummaryView || $[43] !== allowUserDialog || $[44] !== disabled || $[45] !== emojiPickerSize || $[46] !== emojiProvider || $[47] !== flash || $[48] !== handleEmojiPickerTriggerClick || $[49] !== handleOpenReactionsDialog || $[50] !== handleSummaryViewTrayMouseEnter || $[51] !== handleSummaryViewTrayMouseLeave || $[52] !== isEmojiPickerOpen || $[53] !== isViewOnly || $[54] !== onEmojiSelected || $[55] !== onReactionClick || $[56] !== onReactionFocused || $[57] !== onReactionMouseEnter || $[58] !== particleEffectByEmoji || $[59] !== reactionPickerTriggerIcon || $[60] !== reactionPickerTriggerText || $[61] !== reactions || $[62] !== tooltipContent) {
        t24 = (t25)=>{
            const { update: recalculatePopupPosition } = t25;
            return isEmojiPickerOpen ? /*#__PURE__*/ $cozmU.createElement((0, $af2XZ.default), {
                emojiProvider: emojiProvider,
                onSelection: onEmojiSelected,
                size: emojiPickerSize
            }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                testId: $741d424eddcf1ce0$export$55d575bd4bcbc45e,
                onMouseEnter: handleSummaryViewTrayMouseEnter,
                onMouseLeave: handleSummaryViewTrayMouseLeave
            }, allowSelectFromSummaryView && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                testId: "reaction-summary-view-emoji-picker-container"
            }, /*#__PURE__*/ $cozmU.createElement((0, $5a2af3b1f8e184d8$export$41fb9f06171c75f4), {
                disabled: disabled,
                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                tooltipContent: tooltipContent,
                onClick: ()=>{
                    handleEmojiPickerTriggerClick();
                    recalculatePopupPosition();
                },
                showAddReactionText: true,
                reactionPickerTriggerText: reactionPickerTriggerText,
                fullWidthSummaryViewReactionPickerTrigger: true
            })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: shouldRenderReactionSummaryList ? "ul" : undefined,
                xcss: shouldRenderReactionSummaryList ? $741d424eddcf1ce0$var$styles.summaryList : $741d424eddcf1ce0$var$styles.summaryPopup,
                space: "space.025",
                shouldWrap: true,
                alignBlock: "center"
            }, reactions.map((reaction)=>/*#__PURE__*/ $cozmU.createElement((0, $j2uPw.Reaction), {
                    key: reaction.emojiId,
                    rootElement: shouldRenderReactionSummaryList ? "li" : undefined,
                    reaction: reaction,
                    emojiProvider: emojiProvider,
                    onClick: onReactionClick,
                    onFocused: onReactionFocused,
                    onMouseEnter: onReactionMouseEnter,
                    flash: flash[reaction.emojiId],
                    showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                    allowUserDialog: allowUserDialog,
                    handleOpenReactionsDialog: handleOpenReactionsDialog,
                    isViewOnly: isViewOnly
                }))));
        };
        $[42] = allowSelectFromSummaryView;
        $[43] = allowUserDialog;
        $[44] = disabled;
        $[45] = emojiPickerSize;
        $[46] = emojiProvider;
        $[47] = flash;
        $[48] = handleEmojiPickerTriggerClick;
        $[49] = handleOpenReactionsDialog;
        $[50] = handleSummaryViewTrayMouseEnter;
        $[51] = handleSummaryViewTrayMouseLeave;
        $[52] = isEmojiPickerOpen;
        $[53] = isViewOnly;
        $[54] = onEmojiSelected;
        $[55] = onReactionClick;
        $[56] = onReactionFocused;
        $[57] = onReactionMouseEnter;
        $[58] = particleEffectByEmoji;
        $[59] = reactionPickerTriggerIcon;
        $[60] = reactionPickerTriggerText;
        $[61] = reactions;
        $[62] = tooltipContent;
        $[63] = t24;
    } else t24 = $[63];
    const t25 = isSummaryPopupOpen || isEmojiPickerOpen;
    let t26;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = (0, $iDrrr.fg)("platform_a11y_fixes_reading_order");
        $[64] = t26;
    } else t26 = $[64];
    let t27;
    if ($[65] !== emojiProvider || $[66] !== handleButtonMouseEnter || $[67] !== handleButtonMouseLeave || $[68] !== handleSummaryClick || $[69] !== isEmojiPickerOpen || $[70] !== isSummaryPopupOpen || $[71] !== reactions || $[72] !== showOpaqueBackground || $[73] !== subtleReactionsSummaryAndPicker || $[74] !== summaryButtonIconAfter || $[75] !== summaryGetOptimisticImageURL || $[76] !== summaryViewParticleEffectEmojiId || $[77] !== useButtonAlignmentStyling) {
        t27 = (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $c2486cdaea993b56$export$cc50c972184463a7), {
                ...triggerProps,
                emojiProvider: emojiProvider,
                reactions: reactions,
                onClick: handleSummaryClick,
                onMouseEnter: handleButtonMouseEnter,
                onMouseLeave: handleButtonMouseLeave,
                showOpaqueBackground: showOpaqueBackground,
                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                useButtonAlignmentStyling: useButtonAlignmentStyling,
                summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                summaryButtonIconAfter: summaryButtonIconAfter,
                summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId,
                isOpen: isSummaryPopupOpen || isEmojiPickerOpen
            });
        $[65] = emojiProvider;
        $[66] = handleButtonMouseEnter;
        $[67] = handleButtonMouseLeave;
        $[68] = handleSummaryClick;
        $[69] = isEmojiPickerOpen;
        $[70] = isSummaryPopupOpen;
        $[71] = reactions;
        $[72] = showOpaqueBackground;
        $[73] = subtleReactionsSummaryAndPicker;
        $[74] = summaryButtonIconAfter;
        $[75] = summaryGetOptimisticImageURL;
        $[76] = summaryViewParticleEffectEmojiId;
        $[77] = useButtonAlignmentStyling;
        $[78] = t27;
    } else t27 = $[78];
    let t28;
    if ($[79] !== handlePopupClose || $[80] !== placement || $[81] !== t24 || $[82] !== t25 || $[83] !== t27) {
        t28 = /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
            placement: placement,
            content: t24,
            isOpen: t25,
            onClose: handlePopupClose,
            shouldRenderToParent: t26,
            strategy: (0, $iDrrr.fg)("platform_a11y_fixes_reading_order") ? "absolute" : undefined,
            trigger: t27
        });
        $[79] = handlePopupClose;
        $[80] = placement;
        $[81] = t24;
        $[82] = t25;
        $[83] = t27;
        $[84] = t28;
    } else t28 = $[84];
    return t28;
} : ({ emojiProvider: emojiProvider, reactions: reactions = [], flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, placement: placement = 'auto-start', onReactionClick: onReactionClick, onReactionFocused: onReactionFocused, onReactionMouseEnter: onReactionMouseEnter, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, allowSelectFromSummaryView: allowSelectFromSummaryView, disabled: disabled, emojiPickerSize: emojiPickerSize, onSelection: onSelection, tooltipContent: tooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, onOpen: onOpen, useButtonAlignmentStyling: useButtonAlignmentStyling, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, hoverableSummaryViewDelay: hoverableSummaryViewDelay = 300, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId })=>{
    const [isSummaryPopupOpen, setSummaryPopupOpen] = (0, $ca45144c595c321e$export$94d25041dfc7e5be)(false, hoverableSummaryViewDelay);
    const [isHoveringSummaryView, setIsHoveringSummaryView] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonHovered, setIsSummaryViewButtonHovered] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonClicked, setIsSummaryViewButtonClicked] = (0, $cozmU.useState)(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $cozmU.useState)(false); /**
                                                                               * Event callback when the picker is closed
                                                                               * @param _id Optional id if an emoji button was selected or undefined if was clicked outside the picker
                                                                               */ 
    const close = (0, $cozmU.useCallback)((_id)=>{
        setIsEmojiPickerOpen(false); // ufo abort reaction experience
        (0, $97zIA.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
    }, []); /**
           * Event callback when an emoji icon is selected
           * @param item selected item
           */ 
    const onEmojiSelected = (0, $cozmU.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, 'emojiPicker');
        close(item.id);
    }, [
        onSelection,
        close
    ]);
    const handlePopupClose = (0, $cozmU.useCallback)(()=>{
        setSummaryPopupOpen(false, true);
        setIsEmojiPickerOpen(false);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        setSummaryPopupOpen,
        setIsEmojiPickerOpen,
        setIsSummaryViewButtonClicked,
        setIsSummaryViewButtonHovered,
        setIsHoveringSummaryView
    ]);
    const openEmojiPicker = (0, $cozmU.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $97zIA.PickerRender).start();
        onOpen && onOpen(); // ufo reactions picker opened success
        setIsEmojiPickerOpen(true);
        (0, $97zIA.PickerRender).success();
    }, [
        onOpen
    ]);
    const handleEmojiPickerTriggerClick = (0, $cozmU.useCallback)(()=>{
        openEmojiPicker();
        setSummaryPopupOpen(false, true);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        openEmojiPicker,
        setSummaryPopupOpen
    ]);
    const handleSummaryClick = (0, $cozmU.useCallback)(()=>{
        if (hoverableSummaryView) {
            setIsHoveringSummaryView(false);
            setIsSummaryViewButtonHovered(false);
            if (isEmojiPickerOpen || isSummaryViewButtonClicked) {
                // if either the emoji picker is open or the button was clicked, close the popup and reset the state
                setSummaryPopupOpen(false, true);
                setIsSummaryViewButtonClicked(false);
            } else {
                // if neither condition is true, open the popup and set the state
                setSummaryPopupOpen(true, true);
                setIsSummaryViewButtonClicked(true);
            } // close the emoji picker
            setIsEmojiPickerOpen(false);
        } else if (isSummaryPopupOpen) handlePopupClose();
        else setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        isEmojiPickerOpen,
        setSummaryPopupOpen,
        isSummaryPopupOpen,
        handlePopupClose,
        isSummaryViewButtonClicked,
        setIsSummaryViewButtonClicked
    ]);
    const handleButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsSummaryViewButtonHovered(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isEmojiPickerOpen
    ]);
    const handleButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsSummaryViewButtonHovered(false);
        if (hoverableSummaryView && !isHoveringSummaryView && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isHoveringSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isSummaryViewButtonClicked
    ]);
    const handleSummaryViewTrayMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHoveringSummaryView(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsHoveringSummaryView,
        isEmojiPickerOpen
    ]);
    const handleSummaryViewTrayMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHoveringSummaryView(false);
        if (hoverableSummaryView && !isSummaryViewButtonHovered && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isSummaryViewButtonHovered,
        setIsHoveringSummaryView,
        setSummaryPopupOpen,
        isSummaryViewButtonClicked
    ]);
    const shouldRenderReactionSummaryList = (0, $4o0zT.isExperimentEnabled)('platform_a11y_reactions_hover_selector_list');
    return /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
        placement: placement,
        content: ({ update: recalculatePopupPosition })=>isEmojiPickerOpen ? /*#__PURE__*/ $cozmU.createElement((0, $af2XZ.default), {
                emojiProvider: emojiProvider,
                onSelection: onEmojiSelected,
                size: emojiPickerSize
            }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                testId: $741d424eddcf1ce0$export$55d575bd4bcbc45e,
                onMouseEnter: handleSummaryViewTrayMouseEnter,
                onMouseLeave: handleSummaryViewTrayMouseLeave
            }, allowSelectFromSummaryView && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                testId: "reaction-summary-view-emoji-picker-container"
            }, /*#__PURE__*/ $cozmU.createElement((0, $5a2af3b1f8e184d8$export$41fb9f06171c75f4), {
                disabled: disabled,
                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                tooltipContent: tooltipContent,
                onClick: ()=>{
                    handleEmojiPickerTriggerClick();
                    recalculatePopupPosition();
                },
                showAddReactionText: true,
                reactionPickerTriggerText: reactionPickerTriggerText,
                fullWidthSummaryViewReactionPickerTrigger: true
            })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: shouldRenderReactionSummaryList ? 'ul' : undefined,
                xcss: shouldRenderReactionSummaryList ? $741d424eddcf1ce0$var$styles.summaryList : $741d424eddcf1ce0$var$styles.summaryPopup,
                space: "space.025",
                shouldWrap: true,
                alignBlock: "center"
            }, reactions.map((reaction)=>{
                return /*#__PURE__*/ $cozmU.createElement((0, $j2uPw.Reaction), {
                    key: reaction.emojiId,
                    rootElement: shouldRenderReactionSummaryList ? 'li' : undefined,
                    reaction: reaction,
                    emojiProvider: emojiProvider,
                    onClick: onReactionClick,
                    onFocused: onReactionFocused,
                    onMouseEnter: onReactionMouseEnter,
                    flash: flash[reaction.emojiId],
                    showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                    allowUserDialog: allowUserDialog,
                    handleOpenReactionsDialog: handleOpenReactionsDialog,
                    isViewOnly: isViewOnly
                });
            }))),
        isOpen: isSummaryPopupOpen || isEmojiPickerOpen,
        onClose: handlePopupClose,
        shouldRenderToParent: (0, $iDrrr.fg)('platform_a11y_fixes_reading_order'),
        strategy: (0, $iDrrr.fg)('platform_a11y_fixes_reading_order') ? 'absolute' : undefined,
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $c2486cdaea993b56$export$cc50c972184463a7), {
                ...triggerProps,
                emojiProvider: emojiProvider,
                reactions: reactions,
                onClick: handleSummaryClick,
                onMouseEnter: handleButtonMouseEnter,
                onMouseLeave: handleButtonMouseLeave,
                showOpaqueBackground: showOpaqueBackground,
                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                useButtonAlignmentStyling: useButtonAlignmentStyling,
                summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                summaryButtonIconAfter: summaryButtonIconAfter,
                summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId,
                isOpen: isSummaryPopupOpen || isEmojiPickerOpen
            })
    });
};


const $96abc169ab45ec97$var$wrapperStyle = null;
const $96abc169ab45ec97$var$noFlexWrapStyles = null;
const $96abc169ab45ec97$var$noContainerPositionStyles = null;
const $96abc169ab45ec97$var$reactionPickerStyle = null;
const $96abc169ab45ec97$var$listContainerStyles = null; /**
                                   * Set of all available UFO experiences relating to Reactions Dialog
                                   */ 
const $96abc169ab45ec97$export$615f888019c45765 = {
    /**
   * Experience when a reaction dialog is opened
   */ openDialog: (0, $97zIA.ReactionDialogOpened),
    /**
   * Experience when a reaction changed/fetched from inside the modal dialog
   */ selectedReactionChangeInsideDialog: (0, $97zIA.ReactionDialogSelectedReactionChanged)
}; /**
    * Test id for wrapper Reactions div
    */ 
const $96abc169ab45ec97$export$45beea5a8efd4cda = 'render-reactions'; /**
                                                            * Test id for the view all reacted user to trigger the dialog
                                                            */ 
const $96abc169ab45ec97$export$6fd545f57ca8a08a = 'viewall-reacted-users-dialog'; /**
                                                                                    * Test id for summary view of reactions
                                                                                    */ 
const $96abc169ab45ec97$export$23a875699bfce51b = 'reaction-summary-view';
function $96abc169ab45ec97$export$46455b4476d4b8e1(status, errorMessage, tooltipContent) {
    switch(status){
        case (0, $jOmQq.ReactionStatus).error:
            return errorMessage || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).unexpectedError);
        // When reaction is not available don't show any tooltip (e.g. Archive page in Confluence)
        case (0, $jOmQq.ReactionStatus).disabled:
            return null;
        case (0, $jOmQq.ReactionStatus).notLoaded:
        case (0, $jOmQq.ReactionStatus).loading:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).loadingReactions);
        case (0, $jOmQq.ReactionStatus).ready:
            return !!tooltipContent ? tooltipContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).addReaction);
    }
} /**
   * Renders list of reactions
   */ 
const $96abc169ab45ec97$export$44cd1c46d5ca2376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, status: status, errorMessage: errorMessage, loadReaction: loadReaction, quickReactionEmojis: quickReactionEmojis, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, getReactionDetails: getReactionDetails = ()=>{}, onSelection: onSelection, reactions: reactions = [], emojiProvider: emojiProvider, allowAllEmojis: allowAllEmojis, onReactionClick: onReactionClick, allowUserDialog: allowUserDialog, onDialogOpenCallback: onDialogOpenCallback = ()=>{}, onDialogCloseCallback: onDialogCloseCallback = ()=>{}, onDialogSelectReactionCallback: onDialogSelectReactionCallback = ()=>{}, onDialogPageChangeCallback: onDialogPageChangeCallback = ()=>{}, emojiPickerSize: emojiPickerSize = 'medium', miniMode: miniMode = false, summaryViewEnabled: summaryViewEnabled = false, summaryViewThreshold: summaryViewThreshold = 3, summaryViewPlacement: summaryViewPlacement, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, hideDefaultReactions: hideDefaultReactions = false, ProfileCardWrapper: ProfileCardWrapper, onlyRenderPicker: onlyRenderPicker = false, isViewOnly: isViewOnly = false, noWrap: noWrap = false, noRelativeContainer: noRelativeContainer = false, showSubtleDefaultReactions: showSubtleDefaultReactions, reactionPickerTriggerTooltipContent: reactionPickerTriggerTooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, allowSelectFromSummaryView: allowSelectFromSummaryView = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, isListItem: isListItem = false, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, getOptimisticImageURL: getOptimisticImageURL, reactionPickerPlacement: reactionPickerPlacement, summaryButtonIconAfter: summaryButtonIconAfter, renderParticleEffectOnSummaryView: renderParticleEffectOnSummaryView = false, reactionPickerPopperZIndex: reactionPickerPopperZIndex })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [selectedEmojiId, setSelectedEmojiId] = (0, $cozmU.useState)('');
    const [summaryViewParticleEffectEmojiId, setSummaryViewParticleEffectEmojiId] = (0, $cozmU.useState)(null); // if the reactions are empty, then set summaryViewParticleEffectEmojiId to null to clear the particle effect state
    (0, $cozmU.useEffect)(()=>{
        if (reactions.length === 0) setSummaryViewParticleEffectEmojiId(null);
    }, [
        reactions
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let openTime = (0, $cozmU.useRef)();
    let renderTime = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        if (status === (0, $jOmQq.ReactionStatus).notLoaded) loadReaction();
    }, [
        status,
        loadReaction
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (status !== (0, $jOmQq.ReactionStatus).ready) renderTime.current = Date.now();
        else {
            const isSSR = undefined;
            if ((0, $3aKBk.isSampled)((0, $lbdYm.SAMPLING_RATE_REACTIONS_RENDERED_EXP)) && !isSSR) (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionsRenderedEvent), renderTime.current ?? Date.now() //renderTime.current can be null during unit test cases
            );
            renderTime.current = undefined;
        }
    }, [
        createAnalyticsEvent,
        status
    ]);
    const handleReactionMouseEnter = (0, $cozmU.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handleReactionFocused = (0, $cozmU.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handlePickerOpen = (0, $cozmU.useCallback)(()=>{
        openTime.current = Date.now();
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createPickerButtonClickedEvent), reactions.length);
    }, [
        createAnalyticsEvent,
        reactions
    ]);
    const handleOnCancel = (0, $cozmU.useCallback)(()=>{
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createPickerCancelledEvent), openTime.current);
        openTime.current = undefined;
    }, [
        createAnalyticsEvent
    ]);
    const handleOnMore = (0, $cozmU.useCallback)(()=>{
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createPickerMoreClickedEvent), openTime.current);
    }, [
        createAnalyticsEvent
    ]);
    const handleSetSummaryViewParticleEffectEmojiId = (0, $cozmU.useCallback)((emojiId)=>{
        // Find if this emoji is already in existing reactions
        const existingReaction = reactions.find((reaction)=>reaction.emojiId === emojiId); // Only set mostRecentlyClickedId if user hasn't reacted with this emoji yet
        if (!existingReaction?.reacted) setSummaryViewParticleEffectEmojiId({
            id: emojiId,
            shortName: ''
        });
        else setSummaryViewParticleEffectEmojiId(null);
    }, [
        reactions,
        setSummaryViewParticleEffectEmojiId
    ]);
    const handleOnSelection = (0, $cozmU.useCallback)((emojiId, source)=>{
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionSelectionEvent), source, emojiId, reactions.find((reaction)=>reaction.emojiId === emojiId), openTime.current);
        openTime.current = undefined;
        onSelection(emojiId);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        createAnalyticsEvent,
        onSelection,
        reactions,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleSummaryViewReactionClick = (0, $cozmU.useCallback)((emojiId, event)=>{
        onReactionClick(emojiId, event);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        onReactionClick,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleCloseReactionsDialog = (e, analyticsEvent)=>{
        setSelectedEmojiId('');
        onDialogCloseCallback(e, analyticsEvent);
    };
    const handleSelectReactionInDialog = (emojiId)=>{
        // ufo selected reaction inside the modal dialog
        $96abc169ab45ec97$export$615f888019c45765.selectedReactionChangeInsideDialog.start();
        handleReactionMouseEnter(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogSelectReactionCallback(emojiId); // ufo selected reaction inside the modal dialog success
        $96abc169ab45ec97$export$615f888019c45765.selectedReactionChangeInsideDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Selected Emoji changed'
            }
        });
    };
    const handlePaginationChange = (0, $cozmU.useCallback)((emojiId, currentPage, maxPages)=>{
        // fetch the latest active emoji from the new page
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogPageChangeCallback(emojiId, currentPage, maxPages);
    }, // Exclude unstable getReactionDetails to avoid extra re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setSelectedEmojiId
    ]); /**
                          * Get the reactions that we want to render are any reactions with a count greater than zero as well as any default emoji not already shown
                          */ 
    const memorizedReactions = (0, $cozmU.useMemo)(()=>{
        //
        /**
     * If reactions not empty, don't show quick reactions Pre defined emoji or if its empty and default reactions not hidden => return the current list of reactions
     */ if (reactions.length === 0 && hideDefaultReactions || reactions.length > 0 || !quickReactionEmojis) return reactions;
         // add any missing default reactions
        const { ari: ari, containerAri: containerAri, emojiIds: emojiIds } = quickReactionEmojis;
        const items = emojiIds.filter((emojiId)=>!reactions.some((reaction)=>reaction.emojiId === emojiId)).map((emojiId)=>{
            return {
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId,
                count: 0,
                reacted: false
            };
        });
        return reactions.concat(items);
    }, [
        quickReactionEmojis,
        reactions,
        hideDefaultReactions
    ]);
    const shouldShowSummaryView = summaryViewEnabled && memorizedReactions.length >= summaryViewThreshold && reactions.length > 0; // criteria to show Reactions Dialog
    const hasEmojiWithFivePlusReactions = reactions.some((reaction)=>reaction.count >= 5);
    const shouldShowPicker = !isViewOnly && !(!onlyRenderPicker && shouldShowSummaryView && allowSelectFromSummaryView);
    const sortedReactions = (0, $cozmU.useMemo)(()=>{
        return [
            ...memorizedReactions
        ].sort((a, b)=>b?.count - a?.count);
    }, [
        memorizedReactions
    ]); /**
                             * event handler to open dialog with selected reaction
                             * @param emojiId initial emoji id to load dialog with
                             */ 
    const handleOpenReactionsDialog = ({ emojiId: emojiId = sortedReactions[0].emojiId, source: source = 'endOfPageReactions' } = {})=>{
        // ufo start opening reaction dialog
        $96abc169ab45ec97$export$615f888019c45765.openDialog.start();
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogOpenCallback(emojiId, source); // ufo opening reaction dialog success
        $96abc169ab45ec97$export$615f888019c45765.openDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Opening Reactions Dialog successfully'
            }
        });
    };
    const renderReactionItem = (reaction, rootElement)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j2uPw.Reaction), {
            key: reaction.emojiId,
            rootElement: rootElement,
            reaction: reaction,
            emojiProvider: emojiProvider,
            onClick: onReactionClick,
            onMouseEnter: handleReactionMouseEnter,
            onFocused: handleReactionFocused,
            flash: flash[reaction.emojiId],
            showParticleEffect: particleEffectByEmoji[reaction.emojiId],
            showOpaqueBackground: showOpaqueBackground,
            allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
            handleOpenReactionsDialog: handleOpenReactionsDialog,
            isViewOnly: isViewOnly,
            showSubtleStyle: showSubtleDefaultReactions && reactions.length === 0,
            optimisticImageURL: (0, $iDrrr.fg)('platform_reactions_optimistic_url') ? getOptimisticImageURL?.(reaction.emojiId) : undefined
        });
    const renderReactionGroup = ()=>{
        const shouldRenderReactionList = (0, $iDrrr.fg)('jfp_a11y_team_comment_actions_semantic');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "group",
            "aria-label": intl.formatMessage((0, $jFWFL.messages).addedReaction),
            className: (0, $hekY6.default)([
                !shouldRenderReactionList && "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _1mT5xdRAKS",
                !shouldRenderReactionList && noWrap && "_3TGfC9LRg7"
            ])
        }, shouldRenderReactionList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            className: (0, $hekY6.default)([
                "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _1mT5xdRAKS",
                noWrap && "_3TGfC9LRg7"
            ])
        }, memorizedReactions.map((reaction)=>renderReactionItem(reaction, 'li'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, memorizedReactions.map((reaction)=>renderReactionItem(reaction))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $96abc169ab45ec97$export$45beea5a8efd4cda,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _1mT5xdRAKS _0hPCNLDIqT _43nrzT5UaJ _3ptPdXdnbC",
            noWrap && "_3TGfC9LRg7",
            noRelativeContainer && "_1mT5xd5HSx"
        ])
    }, !onlyRenderPicker && (shouldShowSummaryView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $96abc169ab45ec97$export$23a875699bfce51b
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $741d424eddcf1ce0$export$d441f1c2eaaec099), {
        reactions: sortedReactions,
        emojiProvider: emojiProvider,
        flash: flash,
        particleEffectByEmoji: particleEffectByEmoji,
        onSelection: handleOnSelection,
        onReactionClick: handleSummaryViewReactionClick,
        onReactionFocused: handleReactionFocused,
        onReactionMouseEnter: handleReactionMouseEnter,
        placement: summaryViewPlacement,
        showOpaqueBackground: showOpaqueBackground,
        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
        handleOpenReactionsDialog: ()=>handleOpenReactionsDialog({
                source: 'summaryView'
            }),
        allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
        isViewOnly: isViewOnly,
        allowSelectFromSummaryView: allowSelectFromSummaryView,
        disabled: status !== (0, $jOmQq.ReactionStatus).ready,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
        tooltipContent: $96abc169ab45ec97$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
        emojiPickerSize: emojiPickerSize,
        onOpen: handlePickerOpen,
        useButtonAlignmentStyling: useButtonAlignmentStyling,
        reactionPickerTriggerText: reactionPickerTriggerText,
        hoverableSummaryView: hoverableSummaryView,
        summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
        summaryButtonIconAfter: summaryButtonIconAfter,
        summaryViewParticleEffectEmojiId: renderParticleEffectOnSummaryView ? summaryViewParticleEffectEmojiId : null
    })) : reactions.length > 0 && (0, $iDrrr.fg)('platform_reactions_a11y_group_added_reactions') ? renderReactionGroup() : (0, $iDrrr.fg)('jfp_a11y_team_comment_actions_semantic') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _1mT5xdRAKS"
        ])
    }, memorizedReactions.map((reaction)=>renderReactionItem(reaction, 'li'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, memorizedReactions.map((reaction)=>renderReactionItem(reaction)))), shouldShowPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $947dedcc17ccb720$export$1d5ec51e9af399a5), {
        emojiProvider: emojiProvider,
        allowAllEmojis: allowAllEmojis,
        pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
        disabled: status !== (0, $jOmQq.ReactionStatus).ready,
        onSelection: handleOnSelection,
        onOpen: handlePickerOpen,
        onCancel: handleOnCancel,
        onShowMore: handleOnMore,
        tooltipContent: hoverableSummaryView ? null : $96abc169ab45ec97$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
        emojiPickerSize: emojiPickerSize,
        miniMode: miniMode,
        showOpaqueBackground: showOpaqueBackground,
        showAddReactionText: showAddReactionText,
        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
        reactionPickerTriggerText: reactionPickerTriggerText,
        isListItem: isListItem,
        hoverableReactionPicker: hoverableSummaryView,
        hoverableReactionPickerDelay: hoverableSummaryView ? 300 : 0,
        reactionPickerPlacement: reactionPickerPlacement,
        reactionPickerPopperZIndex: reactionPickerPopperZIndex,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _43nrzT1Y8M"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, !!selectedEmojiId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "reactions-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c371858ccc38d3c$export$df84a24235404de6), {
        selectedEmojiId: selectedEmojiId,
        reactions: sortedReactions,
        emojiProvider: emojiProvider,
        handleCloseReactionsDialog: handleCloseReactionsDialog,
        handleSelectReaction: handleSelectReactionInDialog,
        handlePaginationChange: handlePaginationChange,
        ProfileCardWrapper: ProfileCardWrapper
    })))));
});
module.exports["Reactions"] = $96abc169ab45ec97$export$44cd1c46d5ca2376;

});

parcelRegister("3aKBk", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $2iGHk = parcelRequire("2iGHk");


var $852mP = parcelRequire("852mP");

const $7403ad658064272a$var$packageName = "platform-pkg";
const $7403ad658064272a$var$packageVersion = "0.0.0-use.local";
const $7403ad658064272a$export$ed7a494f7df966be = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $7403ad658064272a$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
const $7403ad658064272a$export$1b95a6072f2f9fae = (createAnalyticsEvent, creator, ...args)=>{
    if (createAnalyticsEvent) $7403ad658064272a$export$53eef0dcd9611650(creator(...args))(createAnalyticsEvent);
};
const $7403ad658064272a$var$createPayload = (action, actionSubject, eventType, actionSubjectId)=>(attributes = {})=>({
            action: action,
            actionSubject: actionSubject,
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes,
                packageName: $7403ad658064272a$var$packageName,
                packageVersion: $7403ad658064272a$var$packageVersion
            }
        });
const $7403ad658064272a$var$calculateDuration = (startTime)=>startTime ? Date.now() - startTime : undefined;
const $7403ad658064272a$var$getPreviousState = (reaction)=>{
    if (reaction) {
        if (reaction.reacted) return 'existingReacted';
        return 'existingNotReacted';
    }
    return 'new';
};
const $7403ad658064272a$export$d61cc4fea6b821c6 = (actionSubject)=>$7403ad658064272a$var$createPayload('succeeded', actionSubject, (0, $852mP.OPERATIONAL_EVENT_TYPE))();
const $7403ad658064272a$export$33f46652cacb6853 = (actionSubject, errorCode)=>$7403ad658064272a$var$createPayload('failed', actionSubject, (0, $852mP.OPERATIONAL_EVENT_TYPE))({
        errorCode: errorCode
    });
const $7403ad658064272a$export$fd86d4b03f87495 = (startTime)=>$7403ad658064272a$var$createPayload('rendered', 'reactionView', (0, $852mP.OPERATIONAL_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$5797d4afdfbf7ff2 = (reactionEmojiCount)=>$7403ad658064272a$var$createPayload('clicked', 'reactionPickerButton', (0, $852mP.UI_EVENT_TYPE))({
        reactionEmojiCount: reactionEmojiCount
    });
const $7403ad658064272a$export$aa268ce0cc416ab4 = (startTime)=>$7403ad658064272a$var$createPayload('cancelled', 'reactionPicker', (0, $852mP.UI_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$280ed8781309406f = (startTime)=>$7403ad658064272a$var$createPayload('clicked', 'reactionPicker', (0, $852mP.UI_EVENT_TYPE), 'more')({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$6181167d075f0ec0 = (source, emojiId, reaction, startTime)=>$7403ad658064272a$var$createPayload('clicked', 'reactionPicker', (0, $852mP.UI_EVENT_TYPE), 'emoji')({
        duration: $7403ad658064272a$var$calculateDuration(startTime),
        source: source,
        previousState: $7403ad658064272a$var$getPreviousState(reaction),
        emojiId: emojiId
    });
const $7403ad658064272a$export$c7349958d247ace6 = (startTime)=>$7403ad658064272a$var$createPayload('hovered', 'existingReaction', (0, $852mP.UI_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$2402f68e3d87389c = (startTime)=>$7403ad658064272a$var$createPayload('focused', 'existingReaction', (0, $852mP.UI_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$d3f48819b8df93ec = (added, emojiId)=>$7403ad658064272a$var$createPayload('clicked', 'existingReaction', (0, $852mP.UI_EVENT_TYPE))({
        added: added,
        emojiId: emojiId
    });
const $7403ad658064272a$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};
module.exports["isSampled"] = $7403ad658064272a$export$ed7a494f7df966be;
module.exports["createAndFireSafe"] = $7403ad658064272a$export$1b95a6072f2f9fae;
module.exports["createRestSucceededEvent"] = $7403ad658064272a$export$d61cc4fea6b821c6;
module.exports["createRestFailedEvent"] = $7403ad658064272a$export$33f46652cacb6853;
module.exports["createReactionsRenderedEvent"] = $7403ad658064272a$export$fd86d4b03f87495;
module.exports["createPickerButtonClickedEvent"] = $7403ad658064272a$export$5797d4afdfbf7ff2;
module.exports["createPickerCancelledEvent"] = $7403ad658064272a$export$aa268ce0cc416ab4;
module.exports["createPickerMoreClickedEvent"] = $7403ad658064272a$export$280ed8781309406f;
module.exports["createReactionSelectionEvent"] = $7403ad658064272a$export$6181167d075f0ec0;
module.exports["createReactionHoveredEvent"] = $7403ad658064272a$export$c7349958d247ace6;
module.exports["createReactionFocusedEvent"] = $7403ad658064272a$export$2402f68e3d87389c;
module.exports["createReactionClickedEvent"] = $7403ad658064272a$export$d3f48819b8df93ec;
module.exports["extractErrorInfo"] = $7403ad658064272a$export$74aaf4784c2edb2c;

});

parcelRegister("lbdYm", function(module, exports) {
const $addde3a1004d4e01$export$a1b2ffe56d40782b = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    }
];
const $addde3a1004d4e01$export$f3516ebbf35f82ea = [
    {
        id: 'atlassian-thumbs_up',
        shortName: ':thumbs_up:'
    },
    {
        id: 'atlassian-clap',
        shortName: ':clap:'
    },
    {
        id: 'atlassian-fire',
        shortName: ':fire:'
    },
    {
        id: 'atlassian-red_heart',
        shortName: ':red_heart:'
    },
    {
        id: 'atlassian-surprise',
        shortName: ':surprise:'
    },
    {
        id: 'atlassian-thinking',
        shortName: ':thinking:'
    }
];
const $addde3a1004d4e01$export$86ad6a676949132c = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    },
    {
        id: '1f44e',
        shortName: ':thumbsdown:'
    },
    {
        id: '1f4a1',
        shortName: ':bulb:'
    },
    {
        id: '2b50',
        shortName: ':star:'
    },
    {
        id: '1f49a',
        shortName: ':green_heart:'
    },
    {
        id: '1f499',
        shortName: ':blue_heart:'
    },
    {
        id: '1f494',
        shortName: ':broken_heart:'
    },
    {
        id: '1f600',
        shortName: ':grinning:'
    },
    {
        id: '1f642',
        shortName: ':slight_smile:'
    }
];
const $addde3a1004d4e01$export$d8c2ebcd0ee41219 = new Map($addde3a1004d4e01$export$a1b2ffe56d40782b.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $addde3a1004d4e01$export$bae055b7087a845 = (isTeamojiPickerRefreshEnabled = false)=>isTeamojiPickerRefreshEnabled ? $addde3a1004d4e01$export$f3516ebbf35f82ea : $addde3a1004d4e01$export$a1b2ffe56d40782b;
const $addde3a1004d4e01$export$865044c189f353c2 = new Map($addde3a1004d4e01$export$86ad6a676949132c.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $addde3a1004d4e01$export$59a228d10bdb32fa = 5;
const $addde3a1004d4e01$export$85d1598de110e7b3 = 8;
const $addde3a1004d4e01$export$50b3c15a723386a7 = 50;
const $addde3a1004d4e01$export$d78bee0d9fab78ad = 16;
module.exports["DefaultReactions"] = $addde3a1004d4e01$export$a1b2ffe56d40782b;
module.exports["ExtendedReactions"] = $addde3a1004d4e01$export$86ad6a676949132c;
module.exports["DefaultReactionsByShortName"] = $addde3a1004d4e01$export$d8c2ebcd0ee41219;
module.exports["getDefaultReactions"] = $addde3a1004d4e01$export$bae055b7087a845;
module.exports["ExtendedReactionsByShortName"] = $addde3a1004d4e01$export$865044c189f353c2;
module.exports["TOOLTIP_USERS_LIMIT"] = $addde3a1004d4e01$export$59a228d10bdb32fa;
module.exports["NUMBER_OF_REACTIONS_TO_DISPLAY"] = $addde3a1004d4e01$export$85d1598de110e7b3;
module.exports["SAMPLING_RATE_REACTIONS_RENDERED_EXP"] = $addde3a1004d4e01$export$50b3c15a723386a7;
module.exports["RESOURCED_EMOJI_COMPACT_HEIGHT"] = $addde3a1004d4e01$export$d78bee0d9fab78ad;

});

parcelRegister("jOmQq", function(module, exports) {
var $7022e8c6bf5742d1$export$3618cac445fcd41d = /*#__PURE__*/ function(ReactionUpdateType) {
    ReactionUpdateType["added"] = "added";
    ReactionUpdateType["removed"] = "removed";
    return ReactionUpdateType;
}({});
var $7022e8c6bf5742d1$export$ae1bec9d610f93d3 = /*#__PURE__*/ function(ReactionStatus) {
    ReactionStatus["ready"] = "READY";
    ReactionStatus["loading"] = "LOADING";
    ReactionStatus["error"] = "ERROR";
    ReactionStatus["notLoaded"] = "NOT_LOADED";
    ReactionStatus["disabled"] = "DISABLED";
    return ReactionStatus;
}({});
module.exports["ReactionUpdateType"] = $7022e8c6bf5742d1$export$3618cac445fcd41d;
module.exports["ReactionStatus"] = $7022e8c6bf5742d1$export$ae1bec9d610f93d3;

});

parcelRegister("97zIA", function(module, exports) {

var $fh15z = parcelRequire("fh15z");


var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");


var $53TEx = parcelRequire("53TEx");

/**
 * Helper method for create the config type for an individual/Concurrent experience
 * @param componentName
 */ const $7baed629d8d594eb$var$createExperienceConfig = (componentName, type, performanceType)=>{
    return {
        platform: {
            component: componentName
        },
        type: type,
        performanceType: performanceType
    };
};
var $7baed629d8d594eb$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REACTIONS_RENDERED"] = "reactions-rendered";
    ExperienceName["PICKER_OPENED"] = "reactions-picker-opened";
    ExperienceName["REACTION_ADDED"] = "reaction-added";
    ExperienceName["REACTION_REMOVED"] = "reaction-removed";
    ExperienceName["REACTION_DETAILS_FETCHED"] = "reaction-details-fetched";
    ExperienceName["REACTION_DIALOG_OPENED"] = "reaction-dialog-opened";
    ExperienceName["REACTION_DIALOG_CLOSED"] = "reaction-dialog-closed";
    ExperienceName["REACTION_DIALOG_SELECTED_REACTION_CHANGED"] = "reaction-dialog-selected-reaction-changed";
    ExperienceName["REACTION_DIALOG_PAGE_NAVIGATION"] = "reaction-dialog-page-navigation";
    return ExperienceName;
}({});
var $7baed629d8d594eb$export$57d347d1902b5fe6 = /*#__PURE__*/ function(ComponentName) {
    ComponentName["PICKER_RENDERED"] = "reactions-picker";
    ComponentName["REACTIONS"] = "reactions-list";
    ComponentName["REACTION_ITEM"] = "reaction-item";
    ComponentName["REACTION_DIALOG"] = "reaction-dialog";
    return ComponentName;
}({});
const $7baed629d8d594eb$export$6a3784263f4fa16e = new (0, $cNAch.UFOExperience)("reactions-picker-opened", $7baed629d8d594eb$var$createExperienceConfig("reactions-picker", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$5990348071f4d2f = new (0, $fh15z.ConcurrentExperience)("reactions-rendered", $7baed629d8d594eb$var$createExperienceConfig("reactions-list", (0, $4MiWC.ExperienceTypes).Load, (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad));
const $7baed629d8d594eb$export$2fe905192bb057 = new (0, $fh15z.ConcurrentExperience)("reaction-added", $7baed629d8d594eb$var$createExperienceConfig("reactions-list", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$6d84aa1577071ff0 = new (0, $cNAch.UFOExperience)("reaction-dialog-opened", $7baed629d8d594eb$var$createExperienceConfig("reaction-dialog", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$ef9cf69898a6ff56 = new (0, $cNAch.UFOExperience)("reaction-dialog-selected-reaction-changed", $7baed629d8d594eb$var$createExperienceConfig("reaction-dialog", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$517f7e3ffbcd0621 = new (0, $fh15z.ConcurrentExperience)("reaction-details-fetched", $7baed629d8d594eb$var$createExperienceConfig("reaction-item", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$4f07dc8d2bdd140d = new (0, $fh15z.ConcurrentExperience)("reaction-removed", $7baed629d8d594eb$var$createExperienceConfig("reactions-list", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$45a4d1bf25d8455d = (instanceId)=>(0, $53TEx.withSampling)($7baed629d8d594eb$export$5990348071f4d2f.getInstance(instanceId));
module.exports["ExperienceName"] = $7baed629d8d594eb$export$b881bd9f00ed8ed1;
module.exports["ComponentName"] = $7baed629d8d594eb$export$57d347d1902b5fe6;
module.exports["PickerRender"] = $7baed629d8d594eb$export$6a3784263f4fa16e;
module.exports["ReactionsRendered"] = $7baed629d8d594eb$export$5990348071f4d2f;
module.exports["ReactionsAdd"] = $7baed629d8d594eb$export$2fe905192bb057;
module.exports["ReactionDialogOpened"] = $7baed629d8d594eb$export$6d84aa1577071ff0;
module.exports["ReactionDialogSelectedReactionChanged"] = $7baed629d8d594eb$export$ef9cf69898a6ff56;
module.exports["ReactionDetailsFetch"] = $7baed629d8d594eb$export$517f7e3ffbcd0621;
module.exports["ReactionsRemove"] = $7baed629d8d594eb$export$4f07dc8d2bdd140d;
module.exports["sampledReactionsRendered"] = $7baed629d8d594eb$export$45a4d1bf25d8455d;

});

parcelRegister("j2uPw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $9DHhW = parcelRequire("9DHhW");


var $6OpMl = parcelRequire("6OpMl");


var $iDrrr = parcelRequire("iDrrr");


var $3aKBk = parcelRequire("3aKBk");


var $9UzxD = parcelRequire("9UzxD");


var $e1UZX = parcelRequire("e1UZX");




















var $lpNn5 = parcelRequire("lpNn5");


var $lbdYm = parcelRequire("lbdYm");


var $jFWFL = parcelRequire("jFWFL");

const $6ca35ee292e5704e$export$507197e0ca3872c2 = 5;
const $6ca35ee292e5704e$var$tooltipStyle = null;
const $6ca35ee292e5704e$var$emojiNameStyle = null;
const $6ca35ee292e5704e$var$footerStyle = null;
const $6ca35ee292e5704e$var$underlineStyle = null; // Resets native <button> chrome so it renders as inline text within the tooltip list.
const $6ca35ee292e5704e$var$footerButtonStyle = null;
const $6ca35ee292e5704e$var$footerButtonColorStyle = null; /**
                                      * Test id for wrapper ReactionTooltip div
                                      */ 
const $6ca35ee292e5704e$export$4850cb7690e62d5f = 'render-reactionTooltip';
const $6ca35ee292e5704e$export$22b33b34188069b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: children, emojiName: emojiName, reaction: t1, maxReactions: t2, isEnabled: t3, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, dismissTooltip: dismissTooltip } = t0;
    const { users: t4 } = t1;
    let t5;
    if ($[0] !== allowUserDialog || $[1] !== dismissTooltip || $[2] !== emojiName || $[3] !== handleOpenReactionsDialog || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        const users = t4 === undefined ? [] : t4;
        const maxReactions = t2 === undefined ? (0, $lbdYm.TOOLTIP_USERS_LIMIT) : t2;
        const isEnabled = t3 === undefined ? true : t3;
        let t6;
        if ($[8] !== allowUserDialog || $[9] !== dismissTooltip || $[10] !== handleOpenReactionsDialog) {
            t6 = ()=>{
                if (allowUserDialog && handleOpenReactionsDialog) {
                    dismissTooltip();
                    handleOpenReactionsDialog();
                }
            };
            $[8] = allowUserDialog;
            $[9] = dismissTooltip;
            $[10] = handleOpenReactionsDialog;
            $[11] = t6;
        } else t6 = $[11];
        const handleClick = t6;
        t5 = !users || users.length === 0 || !isEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            tabIndex: (0, $iDrrr.fg)("platform_suppression_removal_fix_reactions") ? undefined : 0,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlb1xp _39HuIbz8Lp _1ANEUSLRg7 _1DCdHiyrFs _0RnPfxYbGa _2nCqgUdnbC _3KMNLzdnbC _4FGVR6dnbC _2Rs5q5dnbC _3yURFsdnbC _0eU7W7dnbC _1rj44LdnbC _1kKzb0dnbC _4Ga63UecOK _44MxIUnQyn _1YODaRnQyn _0nsAOgz8Lp _3krqYeyrFs"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, emojiName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: (0, $hekY6.default)([
                "_41LZZBMRGa _1UtDYze5R3 _1kk5Tk7GSX"
            ])
        }, emojiName) : null, users.slice(0, maxReactions).map($6ca35ee292e5704e$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: (0, $hekY6.default)([
                "_1UtDYze5R3"
            ])
        }, users.length > maxReactions && (allowUserDialog && handleOpenReactionsDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            type: "button",
            onClick: handleClick,
            onMouseDown: $6ca35ee292e5704e$var$_temp2,
            className: (0, $hekY6.default)([
                "_30huDKYbGa _2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _3iDTPbvLZJ _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _39xV02N91d _2fwxA5ecOK _39HuIbz8Lp",
                "_1UtDYze5R3",
                "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _0wOv4Q7zJH _1eOmH6gozt _0clgaMe5R3"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $jFWFL.messages).otherUsers,
            values: {
                count: users.length - maxReactions
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $jFWFL.messages).otherUsers,
            values: {
                count: users.length - maxReactions
            }
        })))));
        $[0] = allowUserDialog;
        $[1] = dismissTooltip;
        $[2] = emojiName;
        $[3] = handleOpenReactionsDialog;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const content = t5;
    let t6;
    if ($[12] !== children) {
        t6 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children);
        $[12] = children;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== content || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: content,
            position: "bottom",
            testId: $6ca35ee292e5704e$export$4850cb7690e62d5f
        }, t6);
        $[14] = content;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ children: children, emojiName: emojiName, reaction: { users: users = [] }, maxReactions: maxReactions = (0, $lbdYm.TOOLTIP_USERS_LIMIT), isEnabled: isEnabled = true, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, dismissTooltip: dismissTooltip })=>{
    const handleClick = ()=>{
        if (allowUserDialog && handleOpenReactionsDialog) {
            dismissTooltip();
            handleOpenReactionsDialog();
        }
    };
    const content = !users || users.length === 0 || !isEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        tabIndex: (0, $iDrrr.fg)('platform_suppression_removal_fix_reactions') ? undefined : 0,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlb1xp _39HuIbz8Lp _1ANEUSLRg7 _1DCdHiyrFs _0RnPfxYbGa _2nCqgUdnbC _3KMNLzdnbC _4FGVR6dnbC _2Rs5q5dnbC _3yURFsdnbC _0eU7W7dnbC _1rj44LdnbC _1kKzb0dnbC _4Ga63UecOK _44MxIUnQyn _1YODaRnQyn _0nsAOgz8Lp _3krqYeyrFs"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, emojiName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_41LZZBMRGa _1UtDYze5R3 _1kk5Tk7GSX"
        ])
    }, emojiName) : null, users.slice(0, maxReactions).map((user)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: user.id
        }, user.displayName);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_1UtDYze5R3"
        ])
    }, users.length > maxReactions && (allowUserDialog && handleOpenReactionsDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        onClick: handleClick,
        onMouseDown: (e)=>e.preventDefault(),
        className: (0, $hekY6.default)([
            "_30huDKYbGa _2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _3iDTPbvLZJ _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _39xV02N91d _2fwxA5ecOK _39HuIbz8Lp",
            "_1UtDYze5R3",
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _0wOv4Q7zJH _1eOmH6gozt _0clgaMe5R3"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $jFWFL.messages).otherUsers,
        values: {
            count: users.length - maxReactions
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $jFWFL.messages).otherUsers,
        values: {
            count: users.length - maxReactions
        }
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: content,
        position: "bottom",
        testId: $6ca35ee292e5704e$export$4850cb7690e62d5f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children));
};
function $6ca35ee292e5704e$var$_temp(user) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        key: user.id
    }, user.displayName);
}
function $6ca35ee292e5704e$var$_temp2(e) {
    return e.preventDefault();
}






var $3TY4f = parcelRequire("3TY4f");





var $3dtSX = parcelRequire("3dtSX");











var $hBYtq = parcelRequire("hBYtq");

const $68378bea7627df85$var$styles = {
    staticReaction: "_4bt5LAnQyn _2WAcuGnQyn _30huDKYbGa _0bjKvDKxmn _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _4ouGXInlTt _0jFU0VoWWg _0KLXru66of _1UtDYzZpcK _43nrzT1Y8M _2xTnZx1Y8M _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0ReiIH18ZR _1eOmH6o126"
};
const $68378bea7627df85$export$1a66ed011c614568 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onMouseEnter: onMouseEnter, onFocus: onFocus, children: children, testId: testId, dataAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const dataAttributes = t2;
    let t3;
    if ($[2] !== children || $[3] !== dataAttributes || $[4] !== onFocus || $[5] !== onMouseEnter || $[6] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onMouseEnter: onMouseEnter,
            onFocus: onFocus,
            testId: testId,
            xcss: $68378bea7627df85$var$styles.staticReaction,
            ...dataAttributes
        }, children);
        $[2] = children;
        $[3] = dataAttributes;
        $[4] = onFocus;
        $[5] = onMouseEnter;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ onMouseEnter: onMouseEnter, onFocus: onFocus, children: children, testId: testId, dataAttributes: dataAttributes = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        testId: testId,
        xcss: $68378bea7627df85$var$styles.staticReaction,
        ...dataAttributes
    }, children);
};



var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

const $7ab9ebaf6ac7f8d6$var$styles = {
    container: "_1mT5xdRAKS",
    listItem: "_2YLqiKPgdg _3SamIHPgdg _2Y7lL4Pgdg _4c065UPgdg",
    listItemNoMarker: "_0aNu0LYbGa"
};
const $7ab9ebaf6ac7f8d6$var$emojiStyle = null;
const $7ab9ebaf6ac7f8d6$var$emojiNoReactionStyle = null; /**
                                    * Test id for Reaction item wrapper div
                                    */ 
const $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111 = 'render_reaction_wrapper';
const $7ab9ebaf6ac7f8d6$export$d2ae4167a30cf6bb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(77);
    const { emojiProvider: emojiProvider, onClick: onClick, reaction: reaction, onMouseEnter: t1, onFocused: t2, flash: t3, showParticleEffect: t4, showOpaqueBackground: t5, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: t6, showSubtleStyle: showSubtleStyle, optimisticImageURL: optimisticImageURL, rootElement: rootElement } = t0;
    const onMouseEnter = t1 === undefined ? $7ab9ebaf6ac7f8d6$var$_temp : t1;
    const onFocused = t2 === undefined ? $7ab9ebaf6ac7f8d6$var$_temp2 : t2;
    const flash = t3 === undefined ? false : t3;
    const showParticleEffect = t4 === undefined ? false : t4;
    const showOpaqueBackground = t5 === undefined ? false : t5;
    const isViewOnly = t6 === undefined ? false : t6;
    const intl = (0, $kSwu1.useIntl)();
    const hoverStart = (0, $cozmU.useRef)();
    const focusStart = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [emojiName, setEmojiName] = (0, $cozmU.useState)();
    const [isTooltipEnabled, setIsTooltipEnabled] = (0, $cozmU.useState)(true);
    const { reacted: reacted } = reaction;
    let t7;
    if ($[0] !== reaction.emojiId) {
        t7 = {
            id: reaction.emojiId,
            shortName: ""
        };
        $[0] = reaction.emojiId;
        $[1] = t7;
    } else t7 = $[1];
    const emojiId = t7;
    let t8;
    let t9;
    if ($[2] !== emojiProvider || $[3] !== reaction.emojiId) {
        t8 = ()=>{
            (async ()=>{
                const emojiResource = await Promise.resolve(emojiProvider);
                const foundEmoji = await emojiResource.findById(reaction.emojiId);
                if (foundEmoji) setEmojiName(foundEmoji.name);
            })();
        };
        t9 = [
            emojiProvider,
            reaction.emojiId
        ];
        $[2] = emojiProvider;
        $[3] = reaction.emojiId;
        $[4] = t8;
        $[5] = t9;
    } else {
        t8 = $[4];
        t9 = $[5];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[6] !== createAnalyticsEvent || $[7] !== onClick || $[8] !== reaction) {
        t10 = (event)=>{
            event.preventDefault();
            if ((0, $3TY4f.isLeftClick)(event)) {
                const { reacted: reacted_0, emojiId: emojiId_0 } = reaction;
                (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionClickedEvent), !reacted_0, emojiId_0);
                onClick(reaction.emojiId, event);
            }
        };
        $[6] = createAnalyticsEvent;
        $[7] = onClick;
        $[8] = reaction;
        $[9] = t10;
    } else t10 = $[9];
    const handleClick = t10;
    let t11;
    if ($[10] !== createAnalyticsEvent || $[11] !== onMouseEnter || $[12] !== reaction.emojiId || $[13] !== reaction.users) {
        t11 = (event_0)=>{
            event_0.preventDefault();
            setIsTooltipEnabled(true);
            if (!reaction.users || !reaction.users.length) focusStart.current = Date.now();
            (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionHoveredEvent), focusStart.current);
            onMouseEnter(reaction.emojiId, event_0);
        };
        $[10] = createAnalyticsEvent;
        $[11] = onMouseEnter;
        $[12] = reaction.emojiId;
        $[13] = reaction.users;
        $[14] = t11;
    } else t11 = $[14];
    const handleMouseEnter = t11;
    let t12;
    if ($[15] !== createAnalyticsEvent || $[16] !== onFocused || $[17] !== reaction.emojiId || $[18] !== reaction.users) {
        t12 = (event_1)=>{
            event_1.preventDefault();
            setIsTooltipEnabled(true);
            if (!reaction.users || !reaction.users.length) hoverStart.current = Date.now();
            (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionFocusedEvent), hoverStart.current);
            onFocused(reaction.emojiId, event_1);
        };
        $[15] = createAnalyticsEvent;
        $[16] = onFocused;
        $[17] = reaction.emojiId;
        $[18] = reaction.users;
        $[19] = t12;
    } else t12 = $[19];
    const handleFocused = t12;
    let t13;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>{
            setIsTooltipEnabled(false);
        };
        $[20] = t13;
    } else t13 = $[20];
    const dismissTooltip = t13;
    const t14 = reaction.count === 0 && "_4c065U1Y8M _0LQT5EuFDC _03SyCPFQfX";
    let t15;
    if ($[21] !== t14) {
        t15 = (0, $hekY6.default)([
            "_4c065U1Y8M _0yKXXaDGiX _26BoRwxpxF _0LQT5E2ADO _03SyCP1Y8M",
            t14
        ]);
        $[21] = t14;
        $[22] = t15;
    } else t15 = $[22];
    let t16;
    if ($[23] !== emojiId || $[24] !== emojiProvider || $[25] !== optimisticImageURL) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            optimisticImageURL: optimisticImageURL
        });
        $[23] = emojiId;
        $[24] = emojiProvider;
        $[25] = optimisticImageURL;
        $[26] = t16;
    } else t16 = $[26];
    let t17;
    if ($[27] !== t15 || $[28] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t15
        }, t16);
        $[27] = t15;
        $[28] = t16;
        $[29] = t17;
    } else t17 = $[29];
    const t18 = !isViewOnly && reaction.reacted;
    let t19;
    if ($[30] !== reaction.count || $[31] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
            value: reaction.count,
            highlight: t18
        });
        $[30] = reaction.count;
        $[31] = t18;
        $[32] = t19;
    } else t19 = $[32];
    let t20;
    if ($[33] !== t17 || $[34] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, t17, t19);
        $[33] = t17;
        $[34] = t19;
        $[35] = t20;
    } else t20 = $[35];
    const emojiAndCount = t20;
    let t21;
    if ($[36] !== emojiName || $[37] !== intl) {
        t21 = intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
            emoji: emojiName
        });
        $[36] = emojiName;
        $[37] = intl;
        $[38] = t21;
    } else t21 = $[38];
    let reactionAriaLabel = t21;
    if (reaction.count) {
        let t22;
        if ($[39] !== emojiName || $[40] !== intl || $[41] !== reaction.count) {
            t22 = intl.formatMessage((0, $jFWFL.messages).reactWithEmojiAndCount, {
                emoji: emojiName,
                count: reaction.count
            });
            $[39] = emojiName;
            $[40] = intl;
            $[41] = reaction.count;
            $[42] = t22;
        } else t22 = $[42];
        reactionAriaLabel = t22;
    }
    const t22 = rootElement === "li" ? $7ab9ebaf6ac7f8d6$var$styles.listItem : undefined;
    let t23;
    if ($[43] !== rootElement) {
        t23 = rootElement === "li" && (0, $iDrrr.fg)("platform_a11y_fixes_reading_order") ? $7ab9ebaf6ac7f8d6$var$styles.listItemNoMarker : undefined;
        $[43] = rootElement;
        $[44] = t23;
    } else t23 = $[44];
    let t24;
    if ($[45] !== t22 || $[46] !== t23) {
        t24 = (0, $w6R6I.cx)($7ab9ebaf6ac7f8d6$var$styles.container, t22, t23);
        $[45] = t22;
        $[46] = t23;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== emojiId || $[49] !== emojiProvider || $[50] !== optimisticImageURL || $[51] !== showParticleEffect) {
        t25 = showParticleEffect && /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
            emojiId: emojiId,
            emojiProvider: emojiProvider,
            optimisticImageURL: optimisticImageURL
        });
        $[48] = emojiId;
        $[49] = emojiProvider;
        $[50] = optimisticImageURL;
        $[51] = showParticleEffect;
        $[52] = t25;
    } else t25 = $[52];
    let t26;
    if ($[53] !== emojiAndCount || $[54] !== flash || $[55] !== handleClick || $[56] !== handleFocused || $[57] !== handleMouseEnter || $[58] !== isViewOnly || $[59] !== reacted || $[60] !== reaction.emojiId || $[61] !== reactionAriaLabel || $[62] !== showOpaqueBackground || $[63] !== showSubtleStyle) {
        t26 = isViewOnly ? /*#__PURE__*/ $cozmU.createElement((0, $68378bea7627df85$export$1a66ed011c614568), {
            onMouseEnter: handleMouseEnter,
            onFocus: handleFocused,
            testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
            dataAttributes: {
                "data-emoji-id": reaction.emojiId
            }
        }, emojiAndCount) : /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
            onClick: handleClick,
            flash: flash,
            ariaLabel: reactionAriaLabel,
            ariaPressed: reacted,
            onMouseEnter: handleMouseEnter,
            onFocus: handleFocused,
            testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
            dataAttributes: {
                "data-emoji-id": reaction.emojiId,
                "data-emoji-button-id": reaction.emojiId
            },
            showOpaqueBackground: showOpaqueBackground,
            showSubtleStyle: showSubtleStyle,
            reacted: reacted
        }, emojiAndCount);
        $[53] = emojiAndCount;
        $[54] = flash;
        $[55] = handleClick;
        $[56] = handleFocused;
        $[57] = handleMouseEnter;
        $[58] = isViewOnly;
        $[59] = reacted;
        $[60] = reaction.emojiId;
        $[61] = reactionAriaLabel;
        $[62] = showOpaqueBackground;
        $[63] = showSubtleStyle;
        $[64] = t26;
    } else t26 = $[64];
    let t27;
    if ($[65] !== allowUserDialog || $[66] !== emojiName || $[67] !== handleOpenReactionsDialog || $[68] !== isTooltipEnabled || $[69] !== reaction || $[70] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $6ca35ee292e5704e$export$22b33b34188069b6), {
            emojiName: emojiName,
            reaction: reaction,
            isEnabled: isTooltipEnabled,
            allowUserDialog: allowUserDialog,
            handleOpenReactionsDialog: handleOpenReactionsDialog,
            dismissTooltip: dismissTooltip
        }, t26);
        $[65] = allowUserDialog;
        $[66] = emojiName;
        $[67] = handleOpenReactionsDialog;
        $[68] = isTooltipEnabled;
        $[69] = reaction;
        $[70] = t26;
        $[71] = t27;
    } else t27 = $[71];
    let t28;
    if ($[72] !== rootElement || $[73] !== t24 || $[74] !== t25 || $[75] !== t27) {
        t28 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t24,
            as: rootElement
        }, t25, t27);
        $[72] = rootElement;
        $[73] = t24;
        $[74] = t25;
        $[75] = t27;
        $[76] = t28;
    } else t28 = $[76];
    return t28;
} : ({ emojiProvider: emojiProvider, onClick: onClick, reaction: reaction, onMouseEnter: onMouseEnter = ()=>{}, onFocused: onFocused = ()=>{}, flash: flash = false, showParticleEffect: showParticleEffect = false, showOpaqueBackground: showOpaqueBackground = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, showSubtleStyle: showSubtleStyle, optimisticImageURL: optimisticImageURL, rootElement: rootElement })=>{
    const intl = (0, $kSwu1.useIntl)();
    const hoverStart = (0, $cozmU.useRef)();
    const focusStart = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [emojiName, setEmojiName] = (0, $cozmU.useState)();
    const [isTooltipEnabled, setIsTooltipEnabled] = (0, $cozmU.useState)(true);
    const { reacted: reacted } = reaction;
    const emojiId = {
        id: reaction.emojiId,
        shortName: ''
    }; // TODO: Extract the flow to a custom hook to retrieve emoji detailed description from an id using a custom hook. This will benefit a better optimization instead of the emojiProvider resolving everytime.
    // Also optimize in future version to fetch in batch several emojiIds
    (0, $cozmU.useEffect)(()=>{
        (async ()=>{
            const emojiResource = await Promise.resolve(emojiProvider);
            const foundEmoji = await emojiResource.findById(reaction.emojiId);
            if (foundEmoji) setEmojiName(foundEmoji.name);
        })();
    }, [
        emojiProvider,
        reaction.emojiId
    ]);
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        if ((0, $3TY4f.isLeftClick)(event)) {
            const { reacted: reacted_0, emojiId: emojiId_0 } = reaction;
            (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionClickedEvent), !reacted_0, emojiId_0);
            onClick(reaction.emojiId, event);
        }
    }, [
        createAnalyticsEvent,
        reaction,
        onClick
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)((event_0)=>{
        event_0.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) focusStart.current = Date.now();
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionHoveredEvent), focusStart.current);
        onMouseEnter(reaction.emojiId, event_0);
    }, [
        createAnalyticsEvent,
        reaction,
        onMouseEnter
    ]);
    const handleFocused = (0, $cozmU.useCallback)((event_1)=>{
        event_1.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) hoverStart.current = Date.now();
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionFocusedEvent), hoverStart.current);
        onFocused(reaction.emojiId, event_1);
    }, [
        createAnalyticsEvent,
        reaction,
        onFocused
    ]);
    const dismissTooltip = ()=>{
        setIsTooltipEnabled(false);
    };
    const emojiAndCount = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4c065U1Y8M _0yKXXaDGiX _26BoRwxpxF _0LQT5E2ADO _03SyCP1Y8M",
            reaction.count === 0 && "_4c065U1Y8M _0LQT5EuFDC _03SyCPFQfX"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
        optimisticImageURL: optimisticImageURL
    })), /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
        value: reaction.count,
        highlight: !isViewOnly && reaction.reacted
    }));
    let reactionAriaLabel = intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
        emoji: emojiName
    });
    if (reaction.count) reactionAriaLabel = intl.formatMessage((0, $jFWFL.messages).reactWithEmojiAndCount, {
        emoji: emojiName,
        count: reaction.count
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($7ab9ebaf6ac7f8d6$var$styles.container, rootElement === 'li' ? $7ab9ebaf6ac7f8d6$var$styles.listItem : undefined, rootElement === 'li' && (0, $iDrrr.fg)('platform_a11y_fixes_reading_order') ? $7ab9ebaf6ac7f8d6$var$styles.listItemNoMarker : undefined),
        as: rootElement
    }, showParticleEffect && /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
        emojiId: emojiId,
        emojiProvider: emojiProvider,
        optimisticImageURL: optimisticImageURL
    }), /*#__PURE__*/ $cozmU.createElement((0, $6ca35ee292e5704e$export$22b33b34188069b6), {
        emojiName: emojiName,
        reaction: reaction,
        isEnabled: isTooltipEnabled,
        allowUserDialog: allowUserDialog,
        handleOpenReactionsDialog: handleOpenReactionsDialog,
        dismissTooltip: dismissTooltip
    }, isViewOnly ? /*#__PURE__*/ $cozmU.createElement((0, $68378bea7627df85$export$1a66ed011c614568), {
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocused,
        testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
        dataAttributes: {
            'data-emoji-id': reaction.emojiId
        }
    }, emojiAndCount) : /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
        onClick: handleClick,
        flash: flash,
        ariaLabel: reactionAriaLabel,
        ariaPressed: reacted,
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocused,
        testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
        dataAttributes: {
            'data-emoji-id': reaction.emojiId,
            'data-emoji-button-id': reaction.emojiId
        },
        showOpaqueBackground: showOpaqueBackground,
        showSubtleStyle: showSubtleStyle,
        reacted: reacted
    }, emojiAndCount)));
};
function $7ab9ebaf6ac7f8d6$var$_temp() {}
function $7ab9ebaf6ac7f8d6$var$_temp2() {}
module.exports["Reaction"] = $7ab9ebaf6ac7f8d6$export$d2ae4167a30cf6bb;

});

parcelRegister("9UzxD", function(module, exports) {
/* Counter.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $j72ee = parcelRequire("j72ee");


var $iODl6 = parcelRequire("iODl6");


var $3TY4f = parcelRequire("3TY4f");

const $5764d4bf4940709b$var$containerStyle = null;
const $5764d4bf4940709b$var$counterLabelStyle = null;
const $5764d4bf4940709b$var$countStyle = null;
const $5764d4bf4940709b$var$highlightStyle = null;
const $5764d4bf4940709b$var$darkerFontStyle = null;
const $5764d4bf4940709b$var$updatedStyles = null; /**
                             * Test id for component top level div
                             */ 
const $5764d4bf4940709b$export$abd04e330cfe02b = 'counter-wrapper'; /**
                                                            * Test id for wrapper div of the counter inside the slider
                                                            */ 
const $5764d4bf4940709b$export$5d72ec7afc5923f4 = 'counter-container'; /**
                                                           * Counter label value wrapper div
                                                           */ 
const $5764d4bf4940709b$export$3b4c1ed5ad4af669 = 'counter_label_wrapper';
const $5764d4bf4940709b$export$1b74141c5fe63a28 = ({ highlight: highlight = false, limit: limit, overLimitLabel: overLimitLabel, className: className, value: value, animationDuration: animationDuration = 'medium', useDarkerFont: useDarkerFont, useUpdatedStyles: useUpdatedStyles })=>{
    const getLabel = (value_0)=>{
        // Check if reached limit
        if (limit && overLimitLabel && value_0 >= limit) return overLimitLabel || '';
        else if (value_0 === 0) return '';
        else return (0, $3TY4f.formatLargeNumber)(value_0);
    };
    const lastValue = (0, $cozmU.useRef)();
    const label = getLabel(value);
    (0, $cozmU.useEffect)(()=>{
        lastValue.current = value;
    }, [
        value
    ]);
    const isIncreasing = (0, $cozmU.useMemo)(()=>{
        return lastValue.current ? lastValue.current < value : false;
    }, [
        value
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _1mT5xdRAKS _0Of8r21Y8M _1Znuxb2ADO _1wydGW1Y8M _2Zuz6QdnbC _26BoRwEbN9",
            useDarkerFont && "_1UtDYzZpcK",
            useUpdatedStyles && "_313842FQfX",
            className
        ]),
        "data-testid": $5764d4bf4940709b$export$abd04e330cfe02b
    }, /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
        enterFrom: isIncreasing ? 'top' : 'bottom',
        exitTo: isIncreasing ? 'top' : 'bottom',
        key: value,
        duration: animationDuration
    }, (motion, direction)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            ref: motion.ref,
            style: {
                position: direction === 'exiting' ? 'absolute' : undefined
            },
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5vbt8w",
                motion.className
            ]),
            "data-testid": $5764d4bf4940709b$export$5d72ec7afc5923f4
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": $5764d4bf4940709b$export$3b4c1ed5ad4af669,
            key: value,
            className: (0, $hekY6.default)([
                "_4zgPmfbiPq",
                highlight && "_1UtDYzjTy9"
            ])
        }, label));
    })));
};
module.exports["Counter"] = $5764d4bf4940709b$export$1b74141c5fe63a28;

});

parcelRegister("e1UZX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6OpMl = parcelRequire("6OpMl");


var $lbdYm = parcelRequire("lbdYm");

const $fe588e33953a56d3$var$containerStyle = null;
const $fe588e33953a56d3$var$reactionParticleStyle = null;
const $fe588e33953a56d3$export$ffc0241869fe445 = 4;
const $fe588e33953a56d3$export$2538eeb2e8d3da5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { emojiProvider: emojiProvider, emojiId: emojiId, optimisticImageURL: optimisticImageURL } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdRAKS _3OE6xYJg58 _42Yu6BpoSI _1sHUMgdnbC"
        ]);
        t2 = [
            ...Array($fe588e33953a56d3$export$ffc0241869fe445)
        ];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== emojiId || $[3] !== emojiProvider || $[4] !== optimisticImageURL) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": true,
            className: t1
        }, t2.map((_, index)=>/*#__PURE__*/ $cozmU.createElement("div", {
                key: index,
                className: (0, $hekY6.default)([
                    "_2fBhte3wI7 _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _1pp6NdYbGa _1YKVNsdnbC _0nFVCG0G4o _47ndRJ8e2l _2cS58fb8VS _0B2GSPJg58 _3Mqk2F0jWM _02fzjrA17z _0weNkOhSmB"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
                emojiProvider: emojiProvider,
                emojiId: emojiId,
                fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
                optimisticImageURL: optimisticImageURL
            }))));
        $[2] = emojiId;
        $[3] = emojiProvider;
        $[4] = optimisticImageURL;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ emojiProvider: emojiProvider, emojiId: emojiId, optimisticImageURL: optimisticImageURL })=>/*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3OE6xYJg58 _42Yu6BpoSI _1sHUMgdnbC"
        ])
    }, [
        ...Array($fe588e33953a56d3$export$ffc0241869fe445)
    ].map((_, index)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            key: index,
            className: (0, $hekY6.default)([
                "_2fBhte3wI7 _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _1pp6NdYbGa _1YKVNsdnbC _0nFVCG0G4o _47ndRJ8e2l _2cS58fb8VS _0B2GSPJg58 _3Mqk2F0jWM _02fzjrA17z _0weNkOhSmB"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            optimisticImageURL: optimisticImageURL
        }));
    }));
module.exports["ReactionParticleEffect"] = $fe588e33953a56d3$export$2538eeb2e8d3da5e;

});

parcelRegister("jFWFL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e3feb1f3f2c9dde8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    addReaction: {
        id: "fabric.reactions.add",
        defaultMessage: "Add reaction"
    },
    addedReaction: {
        id: "reactions.shared.i18n.addedReaction",
        defaultMessage: "Added reaction"
    },
    addNewReaction: {
        id: "fabric.reactions.add.new",
        defaultMessage: "Add new"
    },
    loadingReactions: {
        id: "fabric.reactions.loading",
        defaultMessage: "Loading..."
    },
    moreEmoji: {
        id: "fabric.reactions.more.emojis",
        defaultMessage: "More emojis"
    },
    reactWithEmoji: {
        id: "fabric.reactions.reactwithemoji",
        defaultMessage: "React with {emoji} emoji"
    },
    reactWithEmojiAndCount: {
        id: "fabric.reactions.reactwithemojiandcount",
        defaultMessage: "{count, plural, one {# {emoji} emoji} other {# {emoji} emojis}}. React with {emoji} emoji"
    },
    summary: {
        id: "fabric.reactions.summary",
        defaultMessage: "View all user reactions, {count, plural, one {# reaction} other {# reactions}}"
    },
    unexpectedError: {
        id: "fabric.reactions.error.unexpected",
        defaultMessage: "Reactions are temporarily unavailable"
    },
    otherUsers: {
        id: "fabric.reactions.other.reacted.users",
        defaultMessage: "{count, plural, one {and one other} other {and {count} others}}"
    },
    closeReactionsDialog: {
        id: "reactions.dialog.close",
        defaultMessage: "Close"
    },
    reactionsCount: {
        id: "reactions.dialog.reactions.count",
        defaultMessage: "{count, plural,\n        one {# total reaction}\n        other {# total reactions}\n      }"
    },
    leftNavigateLabel: {
        id: "reactions.dialog.left.navigate",
        defaultMessage: "Left Navigate"
    },
    rightNavigateLabel: {
        id: "reactions.dialog.right.navigate",
        defaultMessage: "Right Navigate"
    },
    emojiName: {
        id: "reactions.dialog.emoji.name",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{emojiName}"
    },
    seeWhoReacted: {
        id: "reactions.dialog.viewall",
        defaultMessage: "View all"
    },
    seeWhoReactedTooltip: {
        id: "reactions.dialog.viewall.tooltip",
        defaultMessage: "View all user reactions"
    },
    popperWrapperLabel: {
        id: "reactions-reaction.picker-label",
        defaultMessage: "Add reactions"
    }
});
module.exports["messages"] = $e3feb1f3f2c9dde8$export$defe85febe8b728c;

});

parcelRegister("3TY4f", function(module, exports) {

var $lbdYm = parcelRequire("lbdYm");

const $0028d9ae1df7c3fc$export$698c4f0ff5e11e52 = (event)=>event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
const $0028d9ae1df7c3fc$export$486a422686c27c1 = (item)=>(0, $lbdYm.DefaultReactions).some((otherEmojiId)=>$0028d9ae1df7c3fc$var$isEqualEmojiId(otherEmojiId, item));
/**
 * compare 2 emoji items if they are same input
 * @param a first emoji item
 * @param b second emoji item
 */ const $0028d9ae1df7c3fc$var$isEqualEmojiId = (a, b)=>{
    if ($0028d9ae1df7c3fc$var$isEmojiId(a) && $0028d9ae1df7c3fc$var$isEmojiId(b)) return a === b || a && b && a.id === b.id && a.shortName === b.shortName;
    else return a === b;
};
/**
 * Type guard if provided object is a string id or an object info collection for the emoji
 * @param item given item
 */ const $0028d9ae1df7c3fc$var$isEmojiId = (item)=>{
    return item.id !== undefined;
};
const $0028d9ae1df7c3fc$export$cabcad7683a98538 = (value, decimalPlaces)=>{
    const decimalIndex = value.indexOf('.');
    if (decimalIndex === -1) // Integers with trailing 0s will have no decimal (Ex. 18000, 7700000, 500)
    return value.substring(0, value.length);
    if (decimalPlaces === 0) // Return an integer value
    return value.substring(0, decimalIndex);
    return value.substring(0, decimalIndex + decimalPlaces + 1);
};
const $0028d9ae1df7c3fc$export$2369f32a5da9d5b8 = (value)=>{
    // 999M+
    const maxLimit = 999999999;
    const thounsandSeparator = 1000;
    const millionSeparator = 1000000;
    const valueInK = value / thounsandSeparator;
    const valueInM = value / millionSeparator;
    if (value > maxLimit) return '999.9M+';
    if (value >= 1000000) {
        // determine the decimal breakpoints by length and check its value
        // 1234567 -> 1.234567 and decimal value is 2
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInM.toString().charAt(numDigits - 5);
        return decimalIndexValue === '0' ? $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInM.toString(), 0) + 'M' : $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInM.toString(), 1) + 'M';
    }
    if (value >= 1000) {
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInK.toString().charAt(numDigits - 2);
        return decimalIndexValue === '0' ? $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInK.toString(), 0) + 'K' : $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInK.toString(), 1) + 'K';
    }
    // <999
    return value.toString();
};
module.exports["isLeftClick"] = $0028d9ae1df7c3fc$export$698c4f0ff5e11e52;
module.exports["formatLargeNumber"] = $0028d9ae1df7c3fc$export$2369f32a5da9d5b8;

});

parcelRegister("3dtSX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $h52mZ = parcelRequire("h52mZ");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $hBYtq = parcelRequire("hBYtq");

const $7a657a940372e424$var$styles = {
    reactionButton: "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _4ouGXInlTt _0jFU0VoWWg _0KLXru66of _1UtDYzZpcK _43nrzT1Y8M _2xTnZx1Y8M _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _1eOmH6o126 _3gzVzLN4oS",
    reactionStylesRefresh: "_0bjKvDKxmn",
    reacted: "_3vBAKHrzt2 _0KLXruY9q9 _1eOmH6sumd _3gzVzLXsxn",
    opaqueBackground: "_0KLXrulfZc _1eOmH6d1Zr _3gzVzLJNoT",
    compactButton: "_0jFU0VSPN1 _0hPCNLDIqT _313842gVvo",
    borderless: "_3hxITiYbGa"
};
/**
 * Default styling px height for an emoji reaction
 */ const $7a657a940372e424$var$akHeight = 24;
const $7a657a940372e424$var$flashHeight = $7a657a940372e424$var$akHeight - 2; // height without the 1px border
const $7a657a940372e424$var$flashStyle = null;
const $7a657a940372e424$var$flashStyleOld = null;
const $7a657a940372e424$export$6ce3894c36b53067 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { onClick: onClick, flash: t1, showSubtleStyle: showSubtleStyle, showOpaqueBackground: showOpaqueBackground, useCompactStyles: useCompactStyles, reacted: reacted, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaPressed: ariaPressed, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, children: children, dataAttributes: t2, testId: testId } = t0;
    const flash = t1 === undefined ? false : t1;
    let t3;
    if ($[0] !== t2) {
        t3 = t2 === undefined ? {} : t2;
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const dataAttributes = t3;
    const t4 = (0, $ieeJu.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true) ? ariaExpanded : undefined;
    const t5 = useCompactStyles && $7a657a940372e424$var$styles.compactButton;
    const t6 = reacted && $7a657a940372e424$var$styles.reacted;
    const t7 = !reacted && showSubtleStyle && $7a657a940372e424$var$styles.borderless;
    const t8 = !reacted && showOpaqueBackground && $7a657a940372e424$var$styles.opaqueBackground;
    let t9;
    if ($[2] !== t5 || $[3] !== t6 || $[4] !== t7 || $[5] !== t8) {
        t9 = (0, $k12R1.cx)($7a657a940372e424$var$styles.reactionButton, t5, t6, t7, t8, (0, $iDrrr.fg)("platform-component-visual-refresh") && $7a657a940372e424$var$styles.reactionStylesRefresh);
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            (0, $iDrrr.fg)("platform-component-visual-refresh") ? "_0bjKvDcjp5 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL" : "_0bjKvDuFDC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL"
        ]);
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] !== children || $[9] !== flash) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $h52mZ.FlashAnimation), {
            flash: flash,
            className: t10
        }, children);
        $[8] = children;
        $[9] = flash;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== ariaLabel || $[12] !== ariaPressed || $[13] !== dataAttributes || $[14] !== onClick || $[15] !== onFocus || $[16] !== onMouseEnter || $[17] !== onMouseLeave || $[18] !== t11 || $[19] !== t4 || $[20] !== t9 || $[21] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            "aria-label": ariaLabel,
            "aria-pressed": ariaPressed,
            "aria-expanded": t4,
            testId: testId,
            xcss: t9,
            ...dataAttributes
        }, t11);
        $[11] = ariaLabel;
        $[12] = ariaPressed;
        $[13] = dataAttributes;
        $[14] = onClick;
        $[15] = onFocus;
        $[16] = onMouseEnter;
        $[17] = onMouseLeave;
        $[18] = t11;
        $[19] = t4;
        $[20] = t9;
        $[21] = testId;
        $[22] = t12;
    } else t12 = $[22];
    return t12;
} : ({ onClick: onClick, flash: flash = false, showSubtleStyle: showSubtleStyle, showOpaqueBackground: showOpaqueBackground, useCompactStyles: useCompactStyles, reacted: reacted, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaPressed: ariaPressed, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, children: children, dataAttributes: dataAttributes = {}, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-expanded": (0, $ieeJu.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true) ? ariaExpanded : undefined,
        testId: testId,
        xcss: (0, $k12R1.cx)($7a657a940372e424$var$styles.reactionButton, useCompactStyles && $7a657a940372e424$var$styles.compactButton, reacted && $7a657a940372e424$var$styles.reacted, !reacted && showSubtleStyle && $7a657a940372e424$var$styles.borderless, !reacted && showOpaqueBackground && $7a657a940372e424$var$styles.opaqueBackground, (0, $iDrrr.fg)('platform-component-visual-refresh') && $7a657a940372e424$var$styles.reactionStylesRefresh),
        ...dataAttributes
    }, /*#__PURE__*/ $cozmU.createElement((0, $h52mZ.FlashAnimation), {
        flash: flash,
        className: (0, $hekY6.default)([
            (0, $iDrrr.fg)('platform-component-visual-refresh') ? "_0bjKvDcjp5 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL" : "_0bjKvDuFDC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL"
        ])
    }, children));
};
module.exports["ReactionButton"] = $7a657a940372e424$export$6ce3894c36b53067;

});

parcelRegister("h52mZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $628c02958bf75670$var$flashTime = 700;
const $628c02958bf75670$var$flashAnimation = null;
const $628c02958bf75670$var$containerStyle = null;
const $628c02958bf75670$var$flashStyle = null;
const $628c02958bf75670$export$101a417749e701a3 = 'flash-animation'; /**
                                                                * Flash animation background component. See Reaction component for usage.
                                                                */ 
const $628c02958bf75670$export$2b501aee548bae06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const t0 = props.flash && "";
    const t1 = props.flash && "_1gBibygdz8 _0nFVCG0G4o _43vdfTN8t6";
    let t2;
    if ($[0] !== props.className || $[1] !== t0 || $[2] !== t1) {
        t2 = (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VN91d",
            t0,
            t1,
            props.className
        ]);
        $[0] = props.className;
        $[1] = t0;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== props.children || $[5] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2,
            "data-testid": $628c02958bf75670$export$101a417749e701a3
        }, props.children);
        $[4] = props.children;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VN91d",
            props.flash && "",
            props.flash && "_1gBibygdz8 _0nFVCG0G4o _43vdfTN8t6",
            props.className
        ]),
        "data-testid": $628c02958bf75670$export$101a417749e701a3
    }, props.children);
module.exports["FlashAnimation"] = $628c02958bf75670$export$2b501aee548bae06;

});


//# sourceMappingURL=render.67bf67f9.js.map
